(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $7f8039d08dcbcec6$exports = {};
!function(t, n) {
    $7f8039d08dcbcec6$exports = n();
}("undefined" != typeof self ? self : $7f8039d08dcbcec6$exports, function() {
    return function() {
        "use strict";
        var t = {
            407: function(t, n, e) {
                e.d(n, {
                    default: function() {
                        return N;
                    }
                });
                var o = /([:*])(\w+)/g, r = /\*/g, i = /\/\?/g;
                function a(t) {
                    return void 0 === t && (t = "/"), v() ? location.pathname + location.search + location.hash : t;
                }
                function s(t) {
                    return t.replace(/\/+$/, "").replace(/^\/+/, "");
                }
                function c(t) {
                    return "string" == typeof t;
                }
                function u(t) {
                    return t && t.indexOf("#") >= 0 && t.split("#").pop() || "";
                }
                function h(t) {
                    var n = s(t).split(/\?(.*)?$/);
                    return [
                        s(n[0]),
                        n.slice(1).join("")
                    ];
                }
                function f(t) {
                    for(var n = {}, e = t.split("&"), o = 0; o < e.length; o++){
                        var r = e[o].split("=");
                        if ("" !== r[0]) {
                            var i = decodeURIComponent(r[0]);
                            n[i] ? (Array.isArray(n[i]) || (n[i] = [
                                n[i]
                            ]), n[i].push(decodeURIComponent(r[1] || ""))) : n[i] = decodeURIComponent(r[1] || "");
                        }
                    }
                    return n;
                }
                function l(t, n) {
                    var e, a = h(s(t.currentLocationPath)), l = a[0], p = a[1], d = "" === p ? null : f(p), v = [];
                    if (c(n.path)) {
                        if (e = "(?:/^|^)" + s(n.path).replace(o, function(t, n, e) {
                            return v.push(e), "([^/]+)";
                        }).replace(r, "?(?:.*)").replace(i, "/?([^/]+|)") + "$", "" === s(n.path) && "" === s(l)) return {
                            url: l,
                            queryString: p,
                            hashString: u(t.to),
                            route: n,
                            data: null,
                            params: d
                        };
                    } else e = n.path;
                    var g = new RegExp(e, ""), m = l.match(g);
                    if (m) {
                        var y = c(n.path) ? function(t, n) {
                            return 0 === n.length ? null : t ? t.slice(1, t.length).reduce(function(t, e, o) {
                                return null === t && (t = {}), t[n[o]] = decodeURIComponent(e), t;
                            }, null) : null;
                        }(m, v) : m.groups ? m.groups : m.slice(1);
                        return {
                            url: s(l.replace(new RegExp("^" + t.instance.root), "")),
                            queryString: p,
                            hashString: u(t.to),
                            route: n,
                            data: y,
                            params: d
                        };
                    }
                    return !1;
                }
                function p() {
                    return !("undefined" == typeof window || !window.history || !window.history.pushState);
                }
                function d(t, n) {
                    return void 0 === t[n] || !0 === t[n];
                }
                function v() {
                    return "undefined" != typeof window;
                }
                function g(t, n) {
                    return void 0 === t && (t = []), void 0 === n && (n = {}), t.filter(function(t) {
                        return t;
                    }).forEach(function(t) {
                        [
                            "before",
                            "after",
                            "already",
                            "leave"
                        ].forEach(function(e) {
                            t[e] && (n[e] || (n[e] = []), n[e].push(t[e]));
                        });
                    }), n;
                }
                function m(t, n, e) {
                    var o = n || {}, r = 0;
                    !function n() {
                        t[r] ? Array.isArray(t[r]) ? (t.splice.apply(t, [
                            r,
                            1
                        ].concat(t[r][0](o) ? t[r][1] : t[r][2])), n()) : t[r](o, function(t) {
                            void 0 === t || !0 === t ? (r += 1, n()) : e && e(o);
                        }) : e && e(o);
                    }();
                }
                function y(t, n) {
                    void 0 === t.currentLocationPath && (t.currentLocationPath = t.to = a(t.instance.root)), t.currentLocationPath = t.instance._checkForAHash(t.currentLocationPath), n();
                }
                function _(t, n) {
                    for(var e = 0; e < t.instance.routes.length; e++){
                        var o = l(t, t.instance.routes[e]);
                        if (o && (t.matches || (t.matches = []), t.matches.push(o), "ONE" === t.resolveOptions.strategy)) return void n();
                    }
                    n();
                }
                function k(t, n) {
                    t.navigateOptions && (void 0 !== t.navigateOptions.shouldResolve && console.warn('"shouldResolve" is deprecated. Please check the documentation.'), void 0 !== t.navigateOptions.silent && console.warn('"silent" is deprecated. Please check the documentation.')), n();
                }
                function O(t, n) {
                    !0 === t.navigateOptions.force ? (t.instance._setCurrent([
                        t.instance._pathToMatchObject(t.to)
                    ]), n(!1)) : n();
                }
                m.if = function(t, n, e) {
                    return Array.isArray(n) || (n = [
                        n
                    ]), Array.isArray(e) || (e = [
                        e
                    ]), [
                        t,
                        n,
                        e
                    ];
                };
                var w = v(), L = p();
                function b(t, n) {
                    if (d(t.navigateOptions, "updateBrowserURL")) {
                        var e = ("/" + t.to).replace(/\/\//g, "/"), o = w && t.resolveOptions && !0 === t.resolveOptions.hash;
                        L ? (history[t.navigateOptions.historyAPIMethod || "pushState"](t.navigateOptions.stateObj || {}, t.navigateOptions.title || "", o ? "#" + e : e), location && location.hash && (t.instance.__freezeListening = !0, setTimeout(function() {
                            if (!o) {
                                var n = location.hash;
                                location.hash = "", location.hash = n;
                            }
                            t.instance.__freezeListening = !1;
                        }, 1))) : w && (window.location.href = t.to);
                    }
                    n();
                }
                function A(t, n) {
                    var e = t.instance;
                    e.lastResolved() ? m(e.lastResolved().map(function(n) {
                        return function(e, o) {
                            if (n.route.hooks && n.route.hooks.leave) {
                                var r = !1, i = t.instance.matchLocation(n.route.path, t.currentLocationPath, !1);
                                r = "*" !== n.route.path ? !i : !(t.matches && t.matches.find(function(t) {
                                    return n.route.path === t.route.path;
                                })), d(t.navigateOptions, "callHooks") && r ? m(n.route.hooks.leave.map(function(n) {
                                    return function(e, o) {
                                        return n(function(n) {
                                            !1 === n ? t.instance.__markAsClean(t) : o();
                                        }, t.matches && t.matches.length > 0 ? 1 === t.matches.length ? t.matches[0] : t.matches : void 0);
                                    };
                                }).concat([
                                    function() {
                                        return o();
                                    }
                                ])) : o();
                            } else o();
                        };
                    }), {}, function() {
                        return n();
                    }) : n();
                }
                function P(t, n) {
                    d(t.navigateOptions, "updateState") && t.instance._setCurrent(t.matches), n();
                }
                var R = [
                    function(t, n) {
                        var e = t.instance.lastResolved();
                        if (e && e[0] && e[0].route === t.match.route && e[0].url === t.match.url && e[0].queryString === t.match.queryString) return e.forEach(function(n) {
                            n.route.hooks && n.route.hooks.already && d(t.navigateOptions, "callHooks") && n.route.hooks.already.forEach(function(n) {
                                return n(t.match);
                            });
                        }), void n(!1);
                        n();
                    },
                    function(t, n) {
                        t.match.route.hooks && t.match.route.hooks.before && d(t.navigateOptions, "callHooks") ? m(t.match.route.hooks.before.map(function(n) {
                            return function(e, o) {
                                return n(function(n) {
                                    !1 === n ? t.instance.__markAsClean(t) : o();
                                }, t.match);
                            };
                        }).concat([
                            function() {
                                return n();
                            }
                        ])) : n();
                    },
                    function(t, n) {
                        d(t.navigateOptions, "callHandler") && t.match.route.handler(t.match), t.instance.updatePageLinks(), n();
                    },
                    function(t, n) {
                        t.match.route.hooks && t.match.route.hooks.after && d(t.navigateOptions, "callHooks") && t.match.route.hooks.after.forEach(function(n) {
                            return n(t.match);
                        }), n();
                    }
                ], S = [
                    A,
                    function(t, n) {
                        var e = t.instance._notFoundRoute;
                        if (e) {
                            t.notFoundHandled = !0;
                            var o = h(t.currentLocationPath), r = o[0], i = o[1], a = u(t.to);
                            e.path = s(r);
                            var c = {
                                url: e.path,
                                queryString: i,
                                hashString: a,
                                data: null,
                                route: e,
                                params: "" !== i ? f(i) : null
                            };
                            t.matches = [
                                c
                            ], t.match = c;
                        }
                        n();
                    },
                    m.if(function(t) {
                        return t.notFoundHandled;
                    }, R.concat([
                        P
                    ]), [
                        function(t, n) {
                            t.resolveOptions && !1 !== t.resolveOptions.noMatchWarning && void 0 !== t.resolveOptions.noMatchWarning || console.warn('Navigo: "' + t.currentLocationPath + "\" didn't match any of the registered routes."), n();
                        },
                        function(t, n) {
                            t.instance._setCurrent(null), n();
                        }
                    ])
                ];
                function E() {
                    return (E = Object.assign || function(t) {
                        for(var n = 1; n < arguments.length; n++){
                            var e = arguments[n];
                            for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                        }
                        return t;
                    }).apply(this, arguments);
                }
                function x(t, n) {
                    var e = 0;
                    A(t, function o() {
                        e !== t.matches.length ? m(R, E({}, t, {
                            match: t.matches[e]
                        }), function() {
                            e += 1, o();
                        }) : P(t, n);
                    });
                }
                function H(t) {
                    t.instance.__markAsClean(t);
                }
                function j() {
                    return (j = Object.assign || function(t) {
                        for(var n = 1; n < arguments.length; n++){
                            var e = arguments[n];
                            for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                        }
                        return t;
                    }).apply(this, arguments);
                }
                var C = "[data-navigo]";
                function N(t, n) {
                    var e, o = n || {
                        strategy: "ONE",
                        hash: !1,
                        noMatchWarning: !1,
                        linksSelector: C
                    }, r = this, i = "/", d = null, w = [], L = !1, A = p(), P = v();
                    function R(t) {
                        return t.indexOf("#") >= 0 && (t = !0 === o.hash ? t.split("#")[1] || "/" : t.split("#")[0]), t;
                    }
                    function E(t) {
                        return s(i + "/" + s(t));
                    }
                    function N(t, n, e, o) {
                        return t = c(t) ? E(t) : t, {
                            name: o || s(String(t)),
                            path: t,
                            handler: n,
                            hooks: g(e)
                        };
                    }
                    function U(t, n) {
                        if (!r.__dirty) {
                            r.__dirty = !0, t = t ? s(i) + "/" + s(t) : void 0;
                            var e = {
                                instance: r,
                                to: t,
                                currentLocationPath: t,
                                navigateOptions: {},
                                resolveOptions: j({}, o, n)
                            };
                            return m([
                                y,
                                _,
                                m.if(function(t) {
                                    var n = t.matches;
                                    return n && n.length > 0;
                                }, x, S)
                            ], e, H), !!e.matches && e.matches;
                        }
                        r.__waiting.push(function() {
                            return r.resolve(t, n);
                        });
                    }
                    function q(t, n) {
                        if (r.__dirty) r.__waiting.push(function() {
                            return r.navigate(t, n);
                        });
                        else {
                            r.__dirty = !0, t = s(i) + "/" + s(t);
                            var e = {
                                instance: r,
                                to: t,
                                navigateOptions: n || {},
                                resolveOptions: n && n.resolveOptions ? n.resolveOptions : o,
                                currentLocationPath: R(t)
                            };
                            m([
                                k,
                                O,
                                _,
                                m.if(function(t) {
                                    var n = t.matches;
                                    return n && n.length > 0;
                                }, x, S),
                                b,
                                H
                            ], e, H);
                        }
                    }
                    function F() {
                        if (P) return (P ? [].slice.call(document.querySelectorAll(o.linksSelector || C)) : []).forEach(function(t) {
                            "false" !== t.getAttribute("data-navigo") && "_blank" !== t.getAttribute("target") ? t.hasListenerAttached || (t.hasListenerAttached = !0, t.navigoHandler = function(n) {
                                if ((n.ctrlKey || n.metaKey) && "a" === n.target.tagName.toLowerCase()) return !1;
                                var e = t.getAttribute("href");
                                if (null == e) return !1;
                                if (e.match(/^(http|https)/) && "undefined" != typeof URL) try {
                                    var o = new URL(e);
                                    e = o.pathname + o.search;
                                } catch (t) {}
                                var i = function(t) {
                                    if (!t) return {};
                                    var n, e = t.split(","), o = {};
                                    return e.forEach(function(t) {
                                        var e = t.split(":").map(function(t) {
                                            return t.replace(/(^ +| +$)/g, "");
                                        });
                                        switch(e[0]){
                                            case "historyAPIMethod":
                                                o.historyAPIMethod = e[1];
                                                break;
                                            case "resolveOptionsStrategy":
                                                n || (n = {}), n.strategy = e[1];
                                                break;
                                            case "resolveOptionsHash":
                                                n || (n = {}), n.hash = "true" === e[1];
                                                break;
                                            case "updateBrowserURL":
                                            case "callHandler":
                                            case "updateState":
                                            case "force":
                                                o[e[0]] = "true" === e[1];
                                        }
                                    }), n && (o.resolveOptions = n), o;
                                }(t.getAttribute("data-navigo-options"));
                                L || (n.preventDefault(), n.stopPropagation(), r.navigate(s(e), i));
                            }, t.addEventListener("click", t.navigoHandler)) : t.hasListenerAttached && t.removeEventListener("click", t.navigoHandler);
                        }), r;
                    }
                    function I(t, n, e) {
                        var o = w.find(function(n) {
                            return n.name === t;
                        }), r = null;
                        if (o) {
                            if (r = o.path, n) for(var a in n)r = r.replace(":" + a, n[a]);
                            r = r.match(/^\//) ? r : "/" + r;
                        }
                        return r && e && !e.includeRoot && (r = r.replace(new RegExp("^/" + i), "")), r;
                    }
                    function M(t) {
                        var n = h(s(t)), o = n[0], r = n[1], i = "" === r ? null : f(r);
                        return {
                            url: o,
                            queryString: r,
                            hashString: u(t),
                            route: N(o, function() {}, [
                                e
                            ], o),
                            data: null,
                            params: i
                        };
                    }
                    function T(t, n, e) {
                        return "string" == typeof n && (n = z(n)), n ? (n.hooks[t] || (n.hooks[t] = []), n.hooks[t].push(e), function() {
                            n.hooks[t] = n.hooks[t].filter(function(t) {
                                return t !== e;
                            });
                        }) : (console.warn("Route doesn't exists: " + n), function() {});
                    }
                    function z(t) {
                        return "string" == typeof t ? w.find(function(n) {
                            return n.name === E(t);
                        }) : w.find(function(n) {
                            return n.handler === t;
                        });
                    }
                    t ? i = s(t) : console.warn('Navigo requires a root path in its constructor. If not provided will use "/" as default.'), this.root = i, this.routes = w, this.destroyed = L, this.current = d, this.__freezeListening = !1, this.__waiting = [], this.__dirty = !1, this.__markAsClean = function(t) {
                        t.instance.__dirty = !1, t.instance.__waiting.length > 0 && t.instance.__waiting.shift()();
                    }, this.on = function(t, n, o) {
                        var r = this;
                        return "object" != typeof t || t instanceof RegExp ? ("function" == typeof t && (o = n, n = t, t = i), w.push(N(t, n, [
                            e,
                            o
                        ])), this) : (Object.keys(t).forEach(function(n) {
                            if ("function" == typeof t[n]) r.on(n, t[n]);
                            else {
                                var o = t[n], i = o.uses, a = o.as, s = o.hooks;
                                w.push(N(n, i, [
                                    e,
                                    s
                                ], a));
                            }
                        }), this);
                    }, this.off = function(t) {
                        return this.routes = w = w.filter(function(n) {
                            return c(t) ? s(n.path) !== s(t) : "function" == typeof t ? t !== n.handler : String(n.path) !== String(t);
                        }), this;
                    }, this.resolve = U, this.navigate = q, this.navigateByName = function(t, n, e) {
                        var o = I(t, n);
                        return null !== o && (q(o.replace(new RegExp("^/?" + i), ""), e), !0);
                    }, this.destroy = function() {
                        this.routes = w = [], A && window.removeEventListener("popstate", this.__popstateListener), this.destroyed = L = !0;
                    }, this.notFound = function(t, n) {
                        return r._notFoundRoute = N("*", t, [
                            e,
                            n
                        ], "__NOT_FOUND__"), this;
                    }, this.updatePageLinks = F, this.link = function(t) {
                        return "/" + i + "/" + s(t);
                    }, this.hooks = function(t) {
                        return e = t, this;
                    }, this.extractGETParameters = function(t) {
                        return h(R(t));
                    }, this.lastResolved = function() {
                        return d;
                    }, this.generate = I, this.getLinkPath = function(t) {
                        return t.getAttribute("href");
                    }, this.match = function(t) {
                        var n = {
                            instance: r,
                            currentLocationPath: t,
                            to: t,
                            navigateOptions: {},
                            resolveOptions: o
                        };
                        return _(n, function() {}), !!n.matches && n.matches;
                    }, this.matchLocation = function(t, n, e) {
                        void 0 === n || void 0 !== e && !e || (n = E(n));
                        var o = {
                            instance: r,
                            to: n,
                            currentLocationPath: n
                        };
                        return y(o, function() {}), "string" == typeof t && (t = void 0 === e || e ? E(t) : t), l(o, {
                            name: String(t),
                            path: t,
                            handler: function() {},
                            hooks: {}
                        }) || !1;
                    }, this.getCurrentLocation = function() {
                        return M(s(a(i)).replace(new RegExp("^" + i), ""));
                    }, this.addBeforeHook = T.bind(this, "before"), this.addAfterHook = T.bind(this, "after"), this.addAlreadyHook = T.bind(this, "already"), this.addLeaveHook = T.bind(this, "leave"), this.getRoute = z, this._pathToMatchObject = M, this._clean = s, this._checkForAHash = R, this._setCurrent = function(t) {
                        return d = r.current = t;
                    }, (function() {
                        A && (this.__popstateListener = function() {
                            r.__freezeListening || U();
                        }, window.addEventListener("popstate", this.__popstateListener));
                    }).call(this), F.call(this);
                }
            }
        }, n = {};
        function e(o) {
            if (n[o]) return n[o].exports;
            var r = n[o] = {
                exports: {}
            };
            return t[o](r, r.exports, e), r.exports;
        }
        return e.d = function(t, n) {
            for(var o in n)e.o(n, o) && !e.o(t, o) && Object.defineProperty(t, o, {
                enumerable: !0,
                get: n[o]
            });
        }, e.o = function(t, n) {
            return Object.prototype.hasOwnProperty.call(t, n);
        }, e(407);
    }().default;
});


/* eslint-disable import/no-unresolved */ var $35ea7bdc381cb865$exports = {};
$35ea7bdc381cb865$exports = "<div class=container id=main-container>\n\t<form id=form novalidate>\n\t\t<input type=hidden name=charge id=charge value=0>\n\t\t<input type=hidden name=total id=total value=0>\n\t\t<input type=hidden name=extra_days id=extra-days value=0>\n\t\t<input type=hidden name=weight id=weight value=0>\n\t\t<input type=hidden name=payment_nonce id=payment-nonce>\n\t\t<input type=hidden name=recaptcha_token id=recaptcha-token>\n\t\t<h1>Booking Form</h1>\n\t\t<div id=steps></div>\n\t\t<div id=recaptcha></div>\n\t</form>\n</div>\n";


var $323d191892a3c904$exports = {};
$323d191892a3c904$exports = "<fieldset id=step-1>\n\t<legend>Step 1: Service Selection</legend>\n\t<div class=row>\n\t\t<div class=\"col-md-4 col-sm-12\">\n\t\t\t<label for=bin-type class=form-label>What Skip Bin Would You Like?\n\t\t\t\t<span class=text-danger>*</span></label>\n\t\t</div>\n\t\t<div class=\"col-md-8 col-sm-12 mb-3\">\n\t\t\t<select name=bin_type id=bin-type class=form-select required>\n\t\t\t\t<option value>Please Select</option>\n\t\t\t\t<option value=\"Garden Skip Bin\">\n\t\t\t\t\tGarden Skip Bin - (100% Green Waste Only)\n\t\t\t\t</option>\n\t\t\t\t<option value=\"Junk Skip Bin\">\n\t\t\t\t\tJunk Skip Bin - (Strictly no Soil, Concrete, Tiles, Rubble\n\t\t\t\t\tetc.)\n\t\t\t\t</option>\n\t\t\t</select>\n\t\t\t<div class=invalid-feedback>Field is required</div>\n\t\t</div>\n\t</div>\n\t<div class=row>\n\t\t<div class=\"col-md-4 col-sm-12\">\n\t\t\t<label for=bin-size class=form-label>Select a Size <span class=text-danger>*</span></label>\n\t\t</div>\n\t\t<div class=\"col-md-8 col-sm-12 mb-3\">\n\t\t\t<select name=bin_size id=bin-size class=form-select required>\n\t\t\t\t<option value>Please Select</option>\n\t\t\t</select>\n\t\t\t<div class=invalid-feedback>Field is required</div>\n\t\t</div>\n\t</div>\n\t<div class=row>\n\t\t<div class=\"col-md-4 col-sm-12\">\n\t\t\t<label class=form-label>Total Price <em>(From)</em></label>\n\t\t</div>\n\t\t<div class=\"col-md-8 col-sm-12 mb-3\">\n\t\t\t<strong>$<span id=charge-display>0.00</span> <em>inc GST</em></strong>\n\t\t</div>\n\t</div>\n\t<div class=row>\n\t\t<div class=\"col-md-4 col-sm-12\">\n\t\t\t<label class=form-label>Weight Allowance</label>\n\t\t</div>\n\t\t<div class=\"col-md-8 col-sm-12 mb-3\">\n\t\t\t<strong><span id=weight-display>0</span>kg</strong>\n\t\t\t<em>(Excess weight is charged at $<span id=weight-rate>0.00</span>\n\t\t\t\tper 100kgs)</em>\n\t\t</div>\n\t</div>\n\t<div class=text-end>\n\t\t<a href=/step-2 class=\"btn btn-lg btn-secondary\" data-current=1 data-step=next>Next</a>\n\t</div>\n</fieldset>\n";


var $8cb04d1943ddc6b0$exports = {};
$8cb04d1943ddc6b0$exports = "<fieldset id=step-2>\n\t<legend>Step 2: Delivery Details</legend>\n\t<div class=row>\n\t\t<div class=\"col-md-6 col-sm-12 mb-3\">\n\t\t\t<label for=delivery-date class=form-label>Delivery Date <span class=text-danger>*</span></label>\n\t\t\t<div class=input-group>\n\t\t\t\t<input name=delivery_date id=delivery-date class=form-control required pattern=^\\d{2}/\\d{2}/\\d{4}$>\n\t\t\t\t<span class=input-group-text id=delivery-date-icon><i class=\"fa-calendar-alt fas\"></i></span>\n\t\t\t</div>\n\t\t\t<div class=invalid-feedback>\n\t\t\t\tA valid delivery date is required\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"col-md-6 col-sm-12 mb-3\">\n\t\t\t<label for=pickup-date class=form-label>Pickup Date <span class=text-danger>*</span></label>\n\t\t\t<div class=input-group>\n\t\t\t\t<input name=pickup_date id=pickup-date class=form-control required pattern=^\\d{2}/\\d{2}/\\d{4}$>\n\t\t\t\t<span class=input-group-text id=pickup-date-icon><i class=\"fa-calendar-alt fas\"></i></span>\n\t\t\t</div>\n\t\t\t<div class=invalid-feedback>A valid pickup date is required</div>\n\t\t</div>\n\t</div>\n\t<div class=\"alert alert-info\" role=alert id=extra-days-info style=display:none>\n\t\t<p>\n\t\t\t<strong>Please note an additional charge of $<span id=extra-days-rate>0.00</span>\n\t\t\t\tper day is incurred if the bin is kept for more than 7\n\t\t\t\tdays:</strong>\n\t\t</p>\n\t\t<ul>\n\t\t\t<li>\n\t\t\t\tBin Hire: $<span id=info-charge-2>0.00</span> <em>inc GST</em>\n\t\t\t</li>\n\t\t\t<li>\n\t\t\t\tExtra Days: $<span id=info-extra-days-2>0.00</span>\n\t\t\t\t<em>inc GST</em>\n\t\t\t</li>\n\t\t\t<li>\n\t\t\t\tSubtotal: $<span id=info-subtotal-2>0.00</span>\n\t\t\t\t<em>inc GST</em>\n\t\t\t</li>\n\t\t</ul>\n\t</div>\n\t<div class=row>\n\t\t<div class=\"col-md-6 col-sm-12 mb-3\">\n\t\t\t<label for=suburb class=form-label>Suburb/Postcode <span class=text-danger>*</span></label>\n\t\t\t<select name=suburb id=suburb class=form-select required>\n\t\t\t\t<option value>Please Select</option>\n\t\t\t</select>\n\t\t\t<div class=invalid-feedback>Field is required</div>\n\t\t</div>\n\t\t<div class=\"col-md-6 col-sm-12 mb-3\">\n\t\t\t<label for=address class=form-label>Address <span class=text-danger>*</span></label>\n\t\t\t<input name=address id=address class=form-control required>\n\t\t\t<div class=invalid-feedback>Field is required</div>\n\t\t</div>\n\t</div>\n\t<div class=row>\n\t\t<div class=\"col-md-12 col-sm-12 mb-3\">\n\t\t\t<label for=delivery-instructions class=form-label>Delivery Instructions</label>\n\t\t\t<textarea name=delivery_instructions id=delivery-instructions class=form-control></textarea>\n\t\t\t<div class=form-text>Where would you like the bin placed?</div>\n\t\t</div>\n\t</div>\n\t<div class=row>\n\t\t<div class=\"col-md-12 col-sm-12 mb-3\">\n\t\t\t<label for=access-issues class=form-label>Access Issues</label>\n\t\t\t<textarea name=access_issues id=access-issues class=form-control></textarea>\n\t\t\t<div class=form-text>eg. locked gates or dogs</div>\n\t\t</div>\n\t</div>\n\t<div class=row>\n\t\t<div class=\"col-md-12 col-sm-12 mb-3\">\n\t\t\t<label for=invoice-address class=form-label>Invoice Address</label>\n\t\t\t<textarea name=invoice_address id=invoice-address class=form-control></textarea>\n\t\t\t<div class=form-text>If Different to Delivery Address</div>\n\t\t</div>\n\t</div>\n\t<div class=row>\n\t\t<div class=col-6>\n\t\t\t<a href=/ class=\"btn btn-lg btn-secondary\" data-current=2 data-step=prev>Prev</a>\n\t\t</div>\n\t\t<div class=\"col-6 text-end\">\n\t\t\t<a href=/step-3 class=\"btn btn-lg btn-secondary\" data-current=2 data-step=next>Next</a>\n\t\t</div>\n\t</div>\n</fieldset>\n";


var $24aba854f01c6ecb$exports = {};
$24aba854f01c6ecb$exports = "<fieldset id=step-3>\n\t<legend>Step 3: Contact Details</legend>\n\t<div class=row>\n\t\t<div class=\"col-md-6 col-sm-12 mb-3\">\n\t\t\t<label for=full-name class=form-label>Your Full Name <span class=text-danger>*</span></label>\n\t\t\t<input name=full_name id=full-name class=form-control required pattern=\"^\\w+ \\w+.*\">\n\t\t\t<div class=invalid-feedback>\n\t\t\t\tYou must provide both first name and last name\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"col-md-6 col-sm-12 mb-3\">\n\t\t\t<label for=email class=form-label>Email Address <span class=text-danger>*</span></label>\n\t\t\t<input type=email name=email id=email class=form-control required>\n\t\t\t<div class=invalid-feedback>Valid email is required</div>\n\t\t</div>\n\t</div>\n\t<div class=row>\n\t\t<div class=\"col-md-6 col-sm-12 mb-3\">\n\t\t\t<label for=mobile class=form-label>Mobile <span class=text-danger>*</span></label>\n\t\t\t<input name=mobile id=mobile class=form-control required pattern=^0(?:4|7)\\d{8}$>\n\t\t\t<div class=invalid-feedback>\n\t\t\t\tA valid phone number is required, e.g. 0410123456, 0712345678\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"col-md-6 col-sm-12 mb-3\">\n\t\t\t<label for=hear-about-us class=form-label>How Did You Hear About Us?</label>\n\t\t\t<select name=hear_about_us id=hear-about-us class=form-select>\n\t\t\t\t<option value>Please Select</option>\n\t\t\t\t<option value=BookaBin>BookaBin</option>\n\t\t\t\t<option value=\"Leaflet Drop\">Leaflet Drop</option>\n\t\t\t\t<option value=\"Local Newspaper\">Local Newspaper</option>\n\t\t\t\t<option value=\"Old Gold Coast Customer\">\n\t\t\t\t\tOld Gold Coast Customer\n\t\t\t\t</option>\n\t\t\t\t<option value=Other/Unknown>Other/Unknown</option>\n\t\t\t\t<option value=\"Our Web Site\">Our Web Site</option>\n\t\t\t\t<option value=\"Previously Used Our Service\">\n\t\t\t\t\tPreviously Used Our Service\n\t\t\t\t</option>\n\t\t\t\t<option value=Radio>Radio</option>\n\t\t\t\t<option value=\"Skip Bins Online\">Skip Bins Online</option>\n\t\t\t\t<option value=\"Truck Sign\">Truck Sign</option>\n\t\t\t\t<option value=\"Web Search (Google etc.)\">\n\t\t\t\t\tWeb Search (Google etc.)\n\t\t\t\t</option>\n\t\t\t\t<option value=\"Word of Mouth\">Word of Mouth</option>\n\t\t\t\t<option value=\"Yellow Pages (Brisbane)\">\n\t\t\t\t\tYellow Pages (Brisbane)\n\t\t\t\t</option>\n\t\t\t\t<option value=\"Yellow Pages Online\">Yellow Pages Online</option>\n\t\t\t</select>\n\t\t</div>\n\t</div>\n\t<div class=row>\n\t\t<div class=col-6>\n\t\t\t<a href=/step-2 class=\"btn btn-lg btn-secondary\" data-current=3 data-step=prev>Prev</a>\n\t\t</div>\n\t\t<div class=\"col-6 text-end\">\n\t\t\t<a href=/step-4 class=\"btn btn-lg btn-secondary\" data-current=3 data-step=next>Next</a>\n\t\t</div>\n\t</div>\n</fieldset>\n";


var $0955b4e2f78c9223$exports = {};
$0955b4e2f78c9223$exports = "<fieldset id=step-4>\n\t<legend>Step 4: Payment Details</legend>\n\t<div class=row>\n\t\t<div class=\"col-md-6 col-sm-12 mb-3\">\n\t\t\t<p>How Would You Like to Pay? <span class=text-danger>*</span></p>\n\t\t\t<div class=form-check>\n\t\t\t\t<input class=form-check-input type=radio name=payment_method id=payment-method-1 value=\"Direct Deposit\" required>\n\t\t\t\t<label class=form-check-label for=payment-method-1>\n\t\t\t\t\tDirect Deposit\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t\n\t\t\t<div class=form-check>\n\t\t\t\t<input class=form-check-input type=radio name=payment_method id=payment-method-3 value=\"Credit Card\" required>\n\t\t\t\t<label class=form-check-label for=payment-method-3>\n\t\t\t\t\tCredit Card\n\t\t\t\t</label>\n\t\t\t</div>\n\t\t\t<div class=invalid-feedback>Field is required</div>\n\t\t</div>\n\t</div>\n\t<div class=row>\n\t\t<div class=\"col-sm-12 mb-3\">\n\t\t\t<div class=form-check>\n\t\t\t\t<input type=checkbox name=agree_terms id=agree-terms class=form-check-input value=Yes required>\n\t\t\t\t<label for=agree-terms class=form-check-label>I agree to the\n\t\t\t\t\t<a href=https://skipbinbrisbane.com.au/terms-and-conditions/ target=_blank>Terms &amp; Conditions</a></label>\n\t\t\t\t<div class=invalid-feedback>\n\t\t\t\t\tYou must agree to the terms and conditions\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\t<div class=\"alert alert-info\" role=alert>\n\t\t<ul>\n\t\t\t<li>\n\t\t\t\tBin Hire: $<span id=info-charge>0.00</span> <em>inc GST</em>\n\t\t\t</li>\n\t\t\t<li>\n\t\t\t\tExtra Days: $<span id=info-extra-days>0.00</span>\n\t\t\t\t<em>inc GST</em>\n\t\t\t</li>\n\t\t\t<li>Total: $<span id=info-total>0.00</span> <em>inc GST</em></li>\n\t\t</ul>\n\t</div>\n\t<div class=\"alert alert-info mb-0\" role=alert id=direct-deposit-info style=display:none>\n\t\t<p><strong>Please transfer full amount to:</strong></p>\n\t\t<ul>\n\t\t\t<li>Account: Ecoclear Waste and Recycling</li>\n\t\t\t<li>BSB: 084-961</li>\n\t\t\t<li>A/C No: 881968563</li>\n\t\t</ul>\n\t</div>\n\t<div id=dropin-wrapper style=display:none>\n\t\t<div id=dropin-container></div>\n\t\t<div class=\"fs-6 invalid-feedback\">\n\t\t\tYou must select a payment method\n\t\t</div>\n\t</div>\n\t<div class=\"alert alert-warning mt-3\" role=alert>\n\t\t<p>\n\t\t\t<strong>Note that your skip bin carries a weight limit of\n\t\t\t\t<span id=weight-display-4>0</span>kg. Exceeding this limit\n\t\t\t\twill incur a $<span id=weight-rate-4>0.00</span> fee per\n\t\t\t\tadditional 100kg.</strong><br>\n\t\t\t<a href=https://skipbinbrisbane.com.au/skip-bin-allowance target=_blank>Click here</a>\n\t\t\tto view the weight allowance for our skip bins.\n\t\t</p>\n\t\t<p>\n\t\t\tThe pickup date we give you is always the Monday week starting date\n\t\t\tso you know which week your pickup is due. However, bags may be\n\t\t\tpicked up at any time between Monday and Friday of that week.\n\t\t</p>\n\t</div>\n\t<div class=\"alert alert-success\" role=alert id=success-alert style=display:none>\n\t\t<p><strong>Success</strong></p>\n\t\t<span id=success-message></span>\n\t</div>\n\t<div class=\"alert alert-danger\" role=alert id=error-alert style=display:none>\n\t\t<p><strong>Error</strong></p>\n\t\t<span id=error-message></span>\n\t</div>\n\t<div class=row>\n\t\t<div class=col-6>\n\t\t\t<a href=/step-3 class=\"btn btn-lg btn-secondary\" data-current=4 data-step=prev>Prev</a>\n\t\t</div>\n\t\t<div class=\"col-6 text-end\">\n\t\t\t<a href=/submit class=\"btn btn-lg btn-secondary\" data-current=4 data-step=next><i class=\"fa-cog fas\" id=submit-cog></i> Finalise</a>\n\t\t</div>\n\t</div>\n</fieldset>\n";


const $ba6ed7a7b724d112$var$config = {
    globalScope: 'skipBinsBookings',
    apiUri: "https://api.skipbinbrisbane.com.au",
    reCaptchaKey: '6Ld4mS0UAAAAAPA8hS7l8hABCuYVMP7C39F06egU'
};
window[$ba6ed7a7b724d112$var$config.globalScope] = window[$ba6ed7a7b724d112$var$config.globalScope] || {};
var $ba6ed7a7b724d112$export$2e2bcd8739ae039 = $ba6ed7a7b724d112$var$config;


const $e96af7e1be5f18d8$var$loadJson = async (fileName)=>{
    const response = await fetch(`https://bookings.skipbinbrisbane.com.au/json/${fileName}.json`, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
    return response.json();
};
const $e96af7e1be5f18d8$var$initStep1 = async (params = {})=>{
    const binType = document.getElementById('bin-type');
    const binSize = document.getElementById('bin-size');
    const charge = document.getElementById('charge');
    const weight = document.getElementById('weight');
    const chargeDisplay = document.getElementById('charge-display');
    const weightDisplay = document.getElementById('weight-display');
    const weightRate = document.getElementById('weight-rate');
    const [bins, costs] = await Promise.all([
        $e96af7e1be5f18d8$var$loadJson('bins'),
        $e96af7e1be5f18d8$var$loadJson('costs')
    ]);
    window[(0, $ba6ed7a7b724d112$export$2e2bcd8739ae039).globalScope].options = {};
    window[(0, $ba6ed7a7b724d112$export$2e2bcd8739ae039).globalScope].options.bins = bins;
    window[(0, $ba6ed7a7b724d112$export$2e2bcd8739ae039).globalScope].options.costs = costs;
    let html = '';
    for(let i = 0; i < bins.length; i += 1){
        const { size: size, cost: cost } = bins[i];
        html += `<option value="${size}m">${size}m<sup>3</sup> Skip Bin - $${cost.toLocaleString('en-AU', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })} inc GST</option>`;
    }
    binSize.insertAdjacentHTML('beforeend', html);
    weightRate.textContent = (costs.per_100kg_over || 0).toFixed(2);
    binSize.addEventListener('change', ()=>{
        const selectedBin = bins.find((bin)=>bin.size === +binSize.value.slice(0, -1)) || {};
        charge.value = selectedBin.cost || 0;
        weight.value = selectedBin.max_weight || 0;
        chargeDisplay.textContent = (selectedBin.cost || 0).toFixed(2);
        weightDisplay.textContent = selectedBin.max_weight || 0;
    });
    const qsParams = params || {};
    if ([
        'garden',
        'junk'
    ].includes(qsParams.type)) binType.value = `${qsParams.type.charAt(0).toUpperCase()}${qsParams.type.slice(1)} Skip Bin`;
    if (qsParams.size) {
        binSize.value = qsParams.size;
        binSize.dispatchEvent(new Event('change'));
    }
};
var $e96af7e1be5f18d8$export$2e2bcd8739ae039 = $e96af7e1be5f18d8$var$initStep1;


function $f505456f79607dba$export$60b8b41c1898ab89(arr) {
    return arr[arr.length - 1];
}
function $f505456f79607dba$export$e91d9f829d98c173(arr, ...items) {
    items.forEach((item)=>{
        if (arr.includes(item)) return;
        arr.push(item);
    });
    return arr;
}
function $f505456f79607dba$export$b9ca061da17f2d30(str, separator) {
    // convert empty string to an empty array
    return str ? str.split(separator) : [];
}
function $f505456f79607dba$export$6dabbcb26357acf4(testVal, min, max) {
    const minOK = min === undefined || testVal >= min;
    const maxOK = max === undefined || testVal <= max;
    return minOK && maxOK;
}
function $f505456f79607dba$export$c6630e295fcd125(val, min, max) {
    if (val < min) return min;
    if (val > max) return max;
    return val;
}
function $f505456f79607dba$export$99349abb93b944f0(tagName, repeat, attributes = {}, index = 0, html = '') {
    const openTagSrc = Object.keys(attributes).reduce((src, attr)=>{
        let val = attributes[attr];
        if (typeof val === 'function') val = val(index);
        return `${src} ${attr}="${val}"`;
    }, tagName);
    html += `<${openTagSrc}></${tagName}>`;
    const next = index + 1;
    return next < repeat ? $f505456f79607dba$export$99349abb93b944f0(tagName, repeat, attributes, next, html) : html;
}
function $f505456f79607dba$export$2c0ac0b7971fd4b0(html) {
    return html.replace(/>\s+/g, '>').replace(/\s+</, '<');
}


function $0ff2c8d69c31afd2$export$bc3ca81ee87aaa35(timeValue) {
    return new Date(timeValue).setHours(0, 0, 0, 0);
}
function $0ff2c8d69c31afd2$export$d0bdf45af03a6ea3() {
    return new Date().setHours(0, 0, 0, 0);
}
function $0ff2c8d69c31afd2$export$63afb81dba78b33e(...args) {
    switch(args.length){
        case 0:
            return $0ff2c8d69c31afd2$export$d0bdf45af03a6ea3();
        case 1:
            return $0ff2c8d69c31afd2$export$bc3ca81ee87aaa35(args[0]);
    }
    // use setFullYear() to keep 2-digit year from being mapped to 1900-1999
    const newDate = new Date(0);
    newDate.setFullYear(...args);
    return newDate.setHours(0, 0, 0, 0);
}
function $0ff2c8d69c31afd2$export$dd412b56f1e4d8aa(date, amount) {
    const newDate = new Date(date);
    return newDate.setDate(newDate.getDate() + amount);
}
function $0ff2c8d69c31afd2$export$ef501a2bb4f3ee6b(date, amount) {
    return $0ff2c8d69c31afd2$export$dd412b56f1e4d8aa(date, amount * 7);
}
function $0ff2c8d69c31afd2$export$17c93e242b2d3a22(date, amount) {
    // If the day of the date is not in the new month, the last day of the new
    // month will be returned. e.g. Jan 31 + 1 month → Feb 28 (not Mar 03)
    const newDate = new Date(date);
    const monthsToSet = newDate.getMonth() + amount;
    let expectedMonth = monthsToSet % 12;
    if (expectedMonth < 0) expectedMonth += 12;
    const time = newDate.setMonth(monthsToSet);
    return newDate.getMonth() !== expectedMonth ? newDate.setDate(0) : time;
}
function $0ff2c8d69c31afd2$export$3d83eec43f4ea476(date, amount) {
    // If the date is Feb 29 and the new year is not a leap year, Feb 28 of the
    // new year will be returned.
    const newDate = new Date(date);
    const expectedMonth = newDate.getMonth();
    const time = newDate.setFullYear(newDate.getFullYear() + amount);
    return expectedMonth === 1 && newDate.getMonth() === 2 ? newDate.setDate(0) : time;
}
// Calculate the distance bettwen 2 days of the week
function $0ff2c8d69c31afd2$var$dayDiff(day, from) {
    return (day - from + 7) % 7;
}
function $0ff2c8d69c31afd2$export$2107381f343b93b3(baseDate, dayOfWeek, weekStart = 0) {
    const baseDay = new Date(baseDate).getDay();
    return $0ff2c8d69c31afd2$export$dd412b56f1e4d8aa(baseDate, $0ff2c8d69c31afd2$var$dayDiff(dayOfWeek, weekStart) - $0ff2c8d69c31afd2$var$dayDiff(baseDay, weekStart));
}
function $0ff2c8d69c31afd2$var$calcWeekNum(dayOfTheWeek, sameDayOfFirstWeek) {
    return Math.round((dayOfTheWeek - sameDayOfFirstWeek) / 604800000) + 1;
}
function $0ff2c8d69c31afd2$export$26888db73f971c93(date) {
    // - Start of ISO week is Monday
    // - Use Thursday for culculation because the first Thursday of ISO week is
    //   always in January
    const thuOfTheWeek = $0ff2c8d69c31afd2$export$2107381f343b93b3(date, 4, 1);
    // - Week 1 in ISO week is the week including Jan 04
    // - Use the Thu of given date's week (instead of given date itself) to
    //   calculate week 1 of the year so that Jan 01 - 03 won't be miscalculated
    //   as week 0 when Jan 04 is Mon - Wed
    const firstThu = $0ff2c8d69c31afd2$export$2107381f343b93b3(new Date(thuOfTheWeek).setMonth(0, 4), 4, 1);
    // return Math.round((thuOfTheWeek - firstThu) / 604800000) + 1;
    return $0ff2c8d69c31afd2$var$calcWeekNum(thuOfTheWeek, firstThu);
}
// Calculate week number in traditional week number system
// @see https://en.wikipedia.org/wiki/Week#Other_week_numbering_systems
function $0ff2c8d69c31afd2$var$calcTraditionalWeekNumber(date, weekStart) {
    // - Week 1 of traditional week is the week including the Jan 01
    // - Use Jan 01 of given date's year to calculate the start of week 1
    const startOfFirstWeek = $0ff2c8d69c31afd2$export$2107381f343b93b3(new Date(date).setMonth(0, 1), weekStart, weekStart);
    const startOfTheWeek = $0ff2c8d69c31afd2$export$2107381f343b93b3(date, weekStart, weekStart);
    const weekNum = $0ff2c8d69c31afd2$var$calcWeekNum(startOfTheWeek, startOfFirstWeek);
    if (weekNum < 53) return weekNum;
    // If the 53rd week includes Jan 01, it's actually next year's week 1
    const weekOneOfNextYear = $0ff2c8d69c31afd2$export$2107381f343b93b3(new Date(date).setDate(32), weekStart, weekStart);
    return startOfTheWeek === weekOneOfNextYear ? 1 : weekNum;
}
function $0ff2c8d69c31afd2$export$2d76cb1fcdb4eb28(date) {
    // Start of Western traditionl week is Sunday
    return $0ff2c8d69c31afd2$var$calcTraditionalWeekNumber(date, 0);
}
function $0ff2c8d69c31afd2$export$f826d24c2f353d8(date) {
    // Start of Middle Eastern week is Saturday
    return $0ff2c8d69c31afd2$var$calcTraditionalWeekNumber(date, 6);
}
function $0ff2c8d69c31afd2$export$30a149176b338f53(date, years) {
    /* @see https://en.wikipedia.org/wiki/Year_zero#ISO_8601 */ const year = new Date(date).getFullYear();
    return Math.floor(year / years) * years;
}
function $0ff2c8d69c31afd2$export$5327a72746f6632f(date, timeSpan, useLastDate) {
    if (timeSpan !== 1 && timeSpan !== 2) return date;
    const newDate = new Date(date);
    if (timeSpan === 1) useLastDate ? newDate.setMonth(newDate.getMonth() + 1, 0) : newDate.setDate(1);
    else useLastDate ? newDate.setFullYear(newDate.getFullYear() + 1, 0, 0) : newDate.setMonth(0, 1);
    return newDate.setHours(0, 0, 0, 0);
}




const $a2e8904b6110f6c8$export$87d4beb3732fc591 = /dd?|DD?|mm?|MM?|yy?(?:yy)?/;
const $a2e8904b6110f6c8$export$954bd430fe699a5e = /[\s!-/:-@[-`{-~年月日]+/;
// cache for persed formats
let $a2e8904b6110f6c8$var$knownFormats = {};
// parse functions for date parts
const $a2e8904b6110f6c8$var$parseFns = {
    y (date, year) {
        return new Date(date).setFullYear(parseInt(year, 10));
    },
    m (date, month, locale) {
        const newDate = new Date(date);
        let monthIndex = parseInt(month, 10) - 1;
        if (isNaN(monthIndex)) {
            if (!month) return NaN;
            const monthName = month.toLowerCase();
            const compareNames = (name)=>name.toLowerCase().startsWith(monthName);
            // compare with both short and full names because some locales have periods
            // in the short names (not equal to the first X letters of the full names)
            monthIndex = locale.monthsShort.findIndex(compareNames);
            if (monthIndex < 0) monthIndex = locale.months.findIndex(compareNames);
            if (monthIndex < 0) return NaN;
        }
        newDate.setMonth(monthIndex);
        return newDate.getMonth() !== $a2e8904b6110f6c8$var$normalizeMonth(monthIndex) ? newDate.setDate(0) : newDate.getTime();
    },
    d (date, day) {
        return new Date(date).setDate(parseInt(day, 10));
    }
};
// format functions for date parts
const $a2e8904b6110f6c8$var$formatFns = {
    d (date) {
        return date.getDate();
    },
    dd (date) {
        return $a2e8904b6110f6c8$var$padZero(date.getDate(), 2);
    },
    D (date, locale) {
        return locale.daysShort[date.getDay()];
    },
    DD (date, locale) {
        return locale.days[date.getDay()];
    },
    m (date) {
        return date.getMonth() + 1;
    },
    mm (date) {
        return $a2e8904b6110f6c8$var$padZero(date.getMonth() + 1, 2);
    },
    M (date, locale) {
        return locale.monthsShort[date.getMonth()];
    },
    MM (date, locale) {
        return locale.months[date.getMonth()];
    },
    y (date) {
        return date.getFullYear();
    },
    yy (date) {
        return $a2e8904b6110f6c8$var$padZero(date.getFullYear(), 2).slice(-2);
    },
    yyyy (date) {
        return $a2e8904b6110f6c8$var$padZero(date.getFullYear(), 4);
    }
};
// get month index in normal range (0 - 11) from any number
function $a2e8904b6110f6c8$var$normalizeMonth(monthIndex) {
    return monthIndex > -1 ? monthIndex % 12 : $a2e8904b6110f6c8$var$normalizeMonth(monthIndex + 12);
}
function $a2e8904b6110f6c8$var$padZero(num, length) {
    return num.toString().padStart(length, '0');
}
function $a2e8904b6110f6c8$var$parseFormatString(format) {
    if (typeof format !== 'string') throw new Error("Invalid date format.");
    if (format in $a2e8904b6110f6c8$var$knownFormats) return $a2e8904b6110f6c8$var$knownFormats[format];
    // sprit the format string into parts and separators
    const separators = format.split($a2e8904b6110f6c8$export$87d4beb3732fc591);
    const parts = format.match(new RegExp($a2e8904b6110f6c8$export$87d4beb3732fc591, 'g'));
    if (separators.length === 0 || !parts) throw new Error("Invalid date format.");
    // collect format functions used in the format
    const partFormatters = parts.map((token)=>$a2e8904b6110f6c8$var$formatFns[token]);
    // collect parse function keys used in the format
    // iterate over parseFns' keys in order to keep the order of the keys.
    const partParserKeys = Object.keys($a2e8904b6110f6c8$var$parseFns).reduce((keys, key)=>{
        const token = parts.find((part)=>part[0] !== 'D' && part[0].toLowerCase() === key);
        if (token) keys.push(key);
        return keys;
    }, []);
    return $a2e8904b6110f6c8$var$knownFormats[format] = {
        parser (dateStr, locale) {
            const dateParts = dateStr.split($a2e8904b6110f6c8$export$954bd430fe699a5e).reduce((dtParts, part, index)=>{
                if (part.length > 0 && parts[index]) {
                    const token = parts[index][0];
                    if (token === 'M') dtParts.m = part;
                    else if (token !== 'D') dtParts[token] = part;
                }
                return dtParts;
            }, {});
            // iterate over partParserkeys so that the parsing is made in the order
            // of year, month and day to prevent the day parser from correcting last
            // day of month wrongly
            return partParserKeys.reduce((origDate, key)=>{
                const newDate = $a2e8904b6110f6c8$var$parseFns[key](origDate, dateParts[key], locale);
                // ignore the part failed to parse
                return isNaN(newDate) ? origDate : newDate;
            }, (0, $0ff2c8d69c31afd2$export$d0bdf45af03a6ea3)());
        },
        formatter (date, locale) {
            let dateStr = partFormatters.reduce((str, fn, index)=>{
                return str += `${separators[index]}${fn(date, locale)}`;
            }, '');
            // separators' length is always parts' length + 1,
            return dateStr += (0, $f505456f79607dba$export$60b8b41c1898ab89)(separators);
        }
    };
}
function $a2e8904b6110f6c8$export$6b862160d295c8e(dateStr, format, locale) {
    if (dateStr instanceof Date || typeof dateStr === 'number') {
        const date = (0, $0ff2c8d69c31afd2$export$bc3ca81ee87aaa35)(dateStr);
        return isNaN(date) ? undefined : date;
    }
    if (!dateStr) return undefined;
    if (dateStr === 'today') return (0, $0ff2c8d69c31afd2$export$d0bdf45af03a6ea3)();
    if (format && format.toValue) {
        const date = format.toValue(dateStr, format, locale);
        return isNaN(date) ? undefined : (0, $0ff2c8d69c31afd2$export$bc3ca81ee87aaa35)(date);
    }
    return $a2e8904b6110f6c8$var$parseFormatString(format).parser(dateStr, locale);
}
function $a2e8904b6110f6c8$export$3ae94a2503e890a1(date, format, locale) {
    if (isNaN(date) || !date && date !== 0) return '';
    const dateObj = typeof date === 'number' ? new Date(date) : date;
    if (format.toDisplay) return format.toDisplay(dateObj, format, locale);
    return $a2e8904b6110f6c8$var$parseFormatString(format).formatter(dateObj, locale);
}


const $f211e3b999ad01fd$var$range = document.createRange();
function $f211e3b999ad01fd$export$8a49393be2d55148(html) {
    return $f211e3b999ad01fd$var$range.createContextualFragment(html);
}
function $f211e3b999ad01fd$export$58081aedf094d85b(el) {
    return el.parentElement || (el.parentNode instanceof ShadowRoot ? el.parentNode.host : undefined);
}
function $f211e3b999ad01fd$export$8a2eb51c14bb8899(el) {
    return el.getRootNode().activeElement === el;
}
function $f211e3b999ad01fd$export$795910f5f15a9633(el) {
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
}
function $f211e3b999ad01fd$export$7669482c90f5c50f(el) {
    if (el.style.display === 'none') return;
    // back up the existing display setting in data-style-display
    if (el.style.display) el.dataset.styleDisplay = el.style.display;
    el.style.display = 'none';
}
function $f211e3b999ad01fd$export$998191bfdf710c72(el) {
    if (el.style.display !== 'none') return;
    if (el.dataset.styleDisplay) {
        // restore backed-up display property
        el.style.display = el.dataset.styleDisplay;
        delete el.dataset.styleDisplay;
    } else el.style.display = '';
}
function $f211e3b999ad01fd$export$8ef79934f06defab(el) {
    if (el.firstChild) {
        el.removeChild(el.firstChild);
        $f211e3b999ad01fd$export$8ef79934f06defab(el);
    }
}
function $f211e3b999ad01fd$export$6ee6eabb13f4dce8(el, newChildNodes) {
    $f211e3b999ad01fd$export$8ef79934f06defab(el);
    if (newChildNodes instanceof DocumentFragment) el.appendChild(newChildNodes);
    else if (typeof newChildNodes === 'string') el.appendChild($f211e3b999ad01fd$export$8a49393be2d55148(newChildNodes));
    else if (typeof newChildNodes.forEach === 'function') newChildNodes.forEach((node)=>{
        el.appendChild(node);
    });
}


const $7d9bfbde81d6cbf0$var$listenerRegistry = new WeakMap();
const { addEventListener: $7d9bfbde81d6cbf0$var$addEventListener, removeEventListener: $7d9bfbde81d6cbf0$var$removeEventListener } = EventTarget.prototype;
function $7d9bfbde81d6cbf0$export$ff47556151e281cc(keyObj, listeners) {
    let registered = $7d9bfbde81d6cbf0$var$listenerRegistry.get(keyObj);
    if (!registered) {
        registered = [];
        $7d9bfbde81d6cbf0$var$listenerRegistry.set(keyObj, registered);
    }
    listeners.forEach((listener)=>{
        $7d9bfbde81d6cbf0$var$addEventListener.call(...listener);
        registered.push(listener);
    });
}
function $7d9bfbde81d6cbf0$export$6d7c595df9011c5(keyObj) {
    let listeners = $7d9bfbde81d6cbf0$var$listenerRegistry.get(keyObj);
    if (!listeners) return;
    listeners.forEach((listener)=>{
        $7d9bfbde81d6cbf0$var$removeEventListener.call(...listener);
    });
    $7d9bfbde81d6cbf0$var$listenerRegistry.delete(keyObj);
}
// Event.composedPath() polyfill for Edge
// based on https://gist.github.com/kleinfreund/e9787d73776c0e3750dcfcdc89f100ec
if (!Event.prototype.composedPath) {
    const getComposedPath = (node, path = [])=>{
        path.push(node);
        let parent;
        if (node.parentNode) parent = node.parentNode;
        else if (node.host) parent = node.host;
        else if (node.defaultView) parent = node.defaultView;
        return parent ? getComposedPath(parent, path) : path;
    };
    Event.prototype.composedPath = function() {
        return getComposedPath(this.target);
    };
}
function $7d9bfbde81d6cbf0$var$findFromPath(path, criteria, currentTarget) {
    const [node, ...rest] = path;
    if (criteria(node)) return node;
    if (node === currentTarget || node.tagName === 'HTML' || rest.length === 0) // stop when reaching currentTarget or <html>
    return;
    return $7d9bfbde81d6cbf0$var$findFromPath(rest, criteria, currentTarget);
}
function $7d9bfbde81d6cbf0$export$f0be97bc7a4f9c42(ev, selector) {
    const criteria = typeof selector === 'function' ? selector : (el)=>el instanceof Element && el.matches(selector);
    return $7d9bfbde81d6cbf0$var$findFromPath(ev.composedPath(), criteria, ev.currentTarget);
}


// default locales
var $5f079e194dccbfe3$export$2e2bcd8739ae039 = {
    en: {
        days: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ],
        daysShort: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        daysMin: [
            "Su",
            "Mo",
            "Tu",
            "We",
            "Th",
            "Fr",
            "Sa"
        ],
        months: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ],
        monthsShort: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        today: "Today",
        clear: "Clear",
        titleFormat: "MM y"
    }
};


// config options updatable by setOptions() and their default values
var $c27ba36c0aa51153$export$2e2bcd8739ae039 = {
    autohide: false,
    beforeShowDay: null,
    beforeShowDecade: null,
    beforeShowMonth: null,
    beforeShowYear: null,
    clearButton: false,
    dateDelimiter: ',',
    datesDisabled: [],
    daysOfWeekDisabled: [],
    daysOfWeekHighlighted: [],
    defaultViewDate: undefined,
    disableTouchKeyboard: false,
    enableOnReadonly: true,
    format: 'mm/dd/yyyy',
    language: 'en',
    maxDate: null,
    maxNumberOfDates: 1,
    maxView: 3,
    minDate: null,
    nextArrow: "\xbb",
    orientation: 'auto',
    pickLevel: 0,
    prevArrow: "\xab",
    showDaysOfWeek: true,
    showOnClick: true,
    showOnFocus: true,
    startView: 0,
    title: '',
    todayButton: false,
    todayButtonMode: 0,
    todayHighlight: false,
    updateOnBlur: true,
    weekNumbers: 0,
    weekStart: 0
};







const { language: $6dc6fcbfb2ef5738$var$defaultLang, format: $6dc6fcbfb2ef5738$var$defaultFormat, weekStart: $6dc6fcbfb2ef5738$var$defaultWeekStart } = (0, $c27ba36c0aa51153$export$2e2bcd8739ae039);
// Reducer function to filter out invalid day-of-week from the input
function $6dc6fcbfb2ef5738$var$sanitizeDOW(dow, day) {
    return dow.length < 6 && day >= 0 && day < 7 ? (0, $f505456f79607dba$export$e91d9f829d98c173)(dow, day) : dow;
}
function $6dc6fcbfb2ef5738$var$determineGetWeekMethod(numberingMode, weekStart) {
    const methodId = numberingMode === 4 ? weekStart === 6 ? 3 : !weekStart + 1 : numberingMode;
    switch(methodId){
        case 1:
            return 0, $0ff2c8d69c31afd2$export$26888db73f971c93;
        case 2:
            return 0, $0ff2c8d69c31afd2$export$2d76cb1fcdb4eb28;
        case 3:
            return 0, $0ff2c8d69c31afd2$export$f826d24c2f353d8;
    }
}
function $6dc6fcbfb2ef5738$var$updateWeekStart(newValue, config, weekNumbers) {
    config.weekStart = newValue;
    config.weekEnd = (newValue + 6) % 7;
    if (weekNumbers === 4) config.getWeekNumber = $6dc6fcbfb2ef5738$var$determineGetWeekMethod(4, newValue);
    return newValue;
}
// validate input date. if invalid, fallback to the original value
function $6dc6fcbfb2ef5738$var$validateDate(value, format, locale, origValue) {
    const date = (0, $a2e8904b6110f6c8$export$6b862160d295c8e)(value, format, locale);
    return date !== undefined ? date : origValue;
}
// Validate viewId. if invalid, fallback to the original value
function $6dc6fcbfb2ef5738$var$validateViewId(value, origValue, max = 3) {
    const viewId = parseInt(value, 10);
    return viewId >= 0 && viewId <= max ? viewId : origValue;
}
function $6dc6fcbfb2ef5738$var$replaceOptions(options, from, to, convert) {
    if (from in options) {
        if (!(to in options)) options[to] = convert ? convert(options[from]) : options[from];
        delete options[from];
    }
}
function $6dc6fcbfb2ef5738$export$2e2bcd8739ae039(options, datepicker) {
    const inOpts = Object.assign({}, options);
    const config = {};
    const locales = datepicker.constructor.locales;
    const rangeEnd = !!datepicker.rangeSideIndex;
    let { datesDisabled: datesDisabled, format: format, language: language, locale: locale, maxDate: maxDate, maxView: maxView, minDate: minDate, pickLevel: pickLevel, startView: startView, weekNumbers: weekNumbers, weekStart: weekStart } = datepicker.config || {};
    // for backward compatibility
    $6dc6fcbfb2ef5738$var$replaceOptions(inOpts, 'calendarWeeks', 'weekNumbers', (val)=>val ? 1 : 0);
    $6dc6fcbfb2ef5738$var$replaceOptions(inOpts, 'clearBtn', 'clearButton');
    $6dc6fcbfb2ef5738$var$replaceOptions(inOpts, 'todayBtn', 'todayButton');
    $6dc6fcbfb2ef5738$var$replaceOptions(inOpts, 'todayBtnMode', 'todayButtonMode');
    if (inOpts.language) {
        let lang;
        if (inOpts.language !== language) {
            if (locales[inOpts.language]) lang = inOpts.language;
            else {
                // Check if language + region tag can fallback to the one without
                // region (e.g. fr-CA → fr)
                lang = inOpts.language.split('-')[0];
                if (!locales[lang]) lang = false;
            }
        }
        delete inOpts.language;
        if (lang) {
            language = config.language = lang;
            // update locale as well when updating language
            const origLocale = locale || locales[$6dc6fcbfb2ef5738$var$defaultLang];
            // use default language's properties for the fallback
            locale = Object.assign({
                format: $6dc6fcbfb2ef5738$var$defaultFormat,
                weekStart: $6dc6fcbfb2ef5738$var$defaultWeekStart
            }, locales[$6dc6fcbfb2ef5738$var$defaultLang]);
            if (language !== $6dc6fcbfb2ef5738$var$defaultLang) Object.assign(locale, locales[language]);
            config.locale = locale;
            // if format and/or weekStart are the same as old locale's defaults,
            // update them to new locale's defaults
            if (format === origLocale.format) format = config.format = locale.format;
            if (weekStart === origLocale.weekStart) weekStart = $6dc6fcbfb2ef5738$var$updateWeekStart(locale.weekStart, config, weekNumbers);
        }
    }
    if (inOpts.format) {
        const hasToDisplay = typeof inOpts.format.toDisplay === 'function';
        const hasToValue = typeof inOpts.format.toValue === 'function';
        const validFormatString = (0, $a2e8904b6110f6c8$export$87d4beb3732fc591).test(inOpts.format);
        if (hasToDisplay && hasToValue || validFormatString) format = config.format = inOpts.format;
        delete inOpts.format;
    }
    //*** pick level ***//
    let newPickLevel = pickLevel;
    if ('pickLevel' in inOpts) {
        newPickLevel = $6dc6fcbfb2ef5738$var$validateViewId(inOpts.pickLevel, pickLevel, 2);
        delete inOpts.pickLevel;
    }
    if (newPickLevel !== pickLevel) {
        if (newPickLevel > pickLevel) {
            // complement current minDate/madDate so that the existing range will be
            // expanded to fit the new level later
            if (!('minDate' in inOpts)) inOpts.minDate = minDate;
            if (!('maxDate' in inOpts)) inOpts.maxDate = maxDate;
        }
        // complement datesDisabled so that it will be reset later
        if (datesDisabled && !inOpts.datesDisabled) inOpts.datesDisabled = [];
        pickLevel = config.pickLevel = newPickLevel;
    }
    //*** dates ***//
    // while min and maxDate for "no limit" in the options are better to be null
    // (especially when updating), the ones in the config have to be undefined
    // because null is treated as 0 (= unix epoch) when comparing with time value
    let minDt = minDate;
    let maxDt = maxDate;
    if ('minDate' in inOpts) {
        const defaultMinDt = (0, $0ff2c8d69c31afd2$export$63afb81dba78b33e)(0, 0, 1);
        minDt = inOpts.minDate === null ? defaultMinDt // set 0000-01-01 to prevent negative values for year
         : $6dc6fcbfb2ef5738$var$validateDate(inOpts.minDate, format, locale, minDt);
        if (minDt !== defaultMinDt) minDt = (0, $0ff2c8d69c31afd2$export$5327a72746f6632f)(minDt, pickLevel, false);
        delete inOpts.minDate;
    }
    if ('maxDate' in inOpts) {
        maxDt = inOpts.maxDate === null ? undefined : $6dc6fcbfb2ef5738$var$validateDate(inOpts.maxDate, format, locale, maxDt);
        if (maxDt !== undefined) maxDt = (0, $0ff2c8d69c31afd2$export$5327a72746f6632f)(maxDt, pickLevel, true);
        delete inOpts.maxDate;
    }
    if (maxDt < minDt) {
        minDate = config.minDate = maxDt;
        maxDate = config.maxDate = minDt;
    } else {
        if (minDate !== minDt) minDate = config.minDate = minDt;
        if (maxDate !== maxDt) maxDate = config.maxDate = maxDt;
    }
    if (inOpts.datesDisabled) {
        const dtsDisabled = inOpts.datesDisabled;
        if (typeof dtsDisabled === 'function') {
            config.datesDisabled = null;
            config.checkDisabled = (timeValue, viewId)=>dtsDisabled(new Date(timeValue), viewId, rangeEnd);
        } else {
            const disabled = config.datesDisabled = dtsDisabled.reduce((dates, dt)=>{
                const date = (0, $a2e8904b6110f6c8$export$6b862160d295c8e)(dt, format, locale);
                return date !== undefined ? (0, $f505456f79607dba$export$e91d9f829d98c173)(dates, (0, $0ff2c8d69c31afd2$export$5327a72746f6632f)(date, pickLevel, rangeEnd)) : dates;
            }, []);
            config.checkDisabled = (timeValue)=>disabled.includes(timeValue);
        }
        delete inOpts.datesDisabled;
    }
    if ('defaultViewDate' in inOpts) {
        const viewDate = (0, $a2e8904b6110f6c8$export$6b862160d295c8e)(inOpts.defaultViewDate, format, locale);
        if (viewDate !== undefined) config.defaultViewDate = viewDate;
        delete inOpts.defaultViewDate;
    }
    //*** days of week ***//
    if ('weekStart' in inOpts) {
        const wkStart = Number(inOpts.weekStart) % 7;
        if (!isNaN(wkStart)) weekStart = $6dc6fcbfb2ef5738$var$updateWeekStart(wkStart, config, weekNumbers);
        delete inOpts.weekStart;
    }
    if (inOpts.daysOfWeekDisabled) {
        config.daysOfWeekDisabled = inOpts.daysOfWeekDisabled.reduce($6dc6fcbfb2ef5738$var$sanitizeDOW, []);
        delete inOpts.daysOfWeekDisabled;
    }
    if (inOpts.daysOfWeekHighlighted) {
        config.daysOfWeekHighlighted = inOpts.daysOfWeekHighlighted.reduce($6dc6fcbfb2ef5738$var$sanitizeDOW, []);
        delete inOpts.daysOfWeekHighlighted;
    }
    //*** week numbers ***//
    if ('weekNumbers' in inOpts) {
        let method = inOpts.weekNumbers;
        if (method) {
            const getWeekNumber = typeof method === 'function' ? (timeValue, startOfWeek)=>method(new Date(timeValue), startOfWeek) : $6dc6fcbfb2ef5738$var$determineGetWeekMethod(method = parseInt(method, 10), weekStart);
            if (getWeekNumber) {
                weekNumbers = config.weekNumbers = method;
                config.getWeekNumber = getWeekNumber;
            }
        } else {
            weekNumbers = config.weekNumbers = 0;
            config.getWeekNumber = null;
        }
        delete inOpts.weekNumbers;
    }
    //*** multi date ***//
    if ('maxNumberOfDates' in inOpts) {
        const maxNumberOfDates = parseInt(inOpts.maxNumberOfDates, 10);
        if (maxNumberOfDates >= 0) {
            config.maxNumberOfDates = maxNumberOfDates;
            config.multidate = maxNumberOfDates !== 1;
        }
        delete inOpts.maxNumberOfDates;
    }
    if (inOpts.dateDelimiter) {
        config.dateDelimiter = String(inOpts.dateDelimiter);
        delete inOpts.dateDelimiter;
    }
    //*** view ***//
    let newMaxView = maxView;
    if ('maxView' in inOpts) {
        newMaxView = $6dc6fcbfb2ef5738$var$validateViewId(inOpts.maxView, maxView);
        delete inOpts.maxView;
    }
    // ensure max view >= pick level
    newMaxView = pickLevel > newMaxView ? pickLevel : newMaxView;
    if (newMaxView !== maxView) maxView = config.maxView = newMaxView;
    let newStartView = startView;
    if ('startView' in inOpts) {
        newStartView = $6dc6fcbfb2ef5738$var$validateViewId(inOpts.startView, newStartView);
        delete inOpts.startView;
    }
    // ensure pick level <= start view <= max view
    if (newStartView < pickLevel) newStartView = pickLevel;
    else if (newStartView > maxView) newStartView = maxView;
    if (newStartView !== startView) config.startView = newStartView;
    //*** template ***//
    if (inOpts.prevArrow) {
        const prevArrow = (0, $f211e3b999ad01fd$export$8a49393be2d55148)(inOpts.prevArrow);
        if (prevArrow.childNodes.length > 0) config.prevArrow = prevArrow.childNodes;
        delete inOpts.prevArrow;
    }
    if (inOpts.nextArrow) {
        const nextArrow = (0, $f211e3b999ad01fd$export$8a49393be2d55148)(inOpts.nextArrow);
        if (nextArrow.childNodes.length > 0) config.nextArrow = nextArrow.childNodes;
        delete inOpts.nextArrow;
    }
    //*** misc ***//
    if ('disableTouchKeyboard' in inOpts) {
        config.disableTouchKeyboard = 'ontouchstart' in document && !!inOpts.disableTouchKeyboard;
        delete inOpts.disableTouchKeyboard;
    }
    if (inOpts.orientation) {
        const orientation = inOpts.orientation.toLowerCase().split(/\s+/g);
        config.orientation = {
            x: orientation.find((x)=>x === 'left' || x === 'right') || 'auto',
            y: orientation.find((y)=>y === 'top' || y === 'bottom') || 'auto'
        };
        delete inOpts.orientation;
    }
    if ('todayButtonMode' in inOpts) {
        switch(inOpts.todayButtonMode){
            case 0:
            case 1:
                config.todayButtonMode = inOpts.todayButtonMode;
        }
        delete inOpts.todayButtonMode;
    }
    //*** copy the rest ***//
    Object.entries(inOpts).forEach(([key, value])=>{
        if (value !== undefined && key in (0, $c27ba36c0aa51153$export$2e2bcd8739ae039)) config[key] = value;
    });
    return config;
}


const $40093450f3cc365f$var$defaultShortcutKeys = {
    show: {
        key: 'ArrowDown'
    },
    hide: null,
    toggle: {
        key: 'Escape'
    },
    prevButton: {
        key: 'ArrowLeft',
        ctrlOrMetaKey: true
    },
    nextButton: {
        key: 'ArrowRight',
        ctrlOrMetaKey: true
    },
    viewSwitch: {
        key: 'ArrowUp',
        ctrlOrMetaKey: true
    },
    clearButton: {
        key: 'Backspace',
        ctrlOrMetaKey: true
    },
    todayButton: {
        key: '.',
        ctrlOrMetaKey: true
    },
    exitEditMode: {
        key: 'ArrowDown',
        ctrlOrMetaKey: true
    }
};
function $40093450f3cc365f$export$2e2bcd8739ae039(options) {
    return Object.keys($40093450f3cc365f$var$defaultShortcutKeys).reduce((keyDefs, shortcut)=>{
        const keyDef = options[shortcut] === undefined ? $40093450f3cc365f$var$defaultShortcutKeys[shortcut] : options[shortcut];
        const key = keyDef && keyDef.key;
        if (!key || typeof key !== 'string') return keyDefs;
        const normalizedDef = {
            key: key,
            ctrlOrMetaKey: !!(keyDef.ctrlOrMetaKey || keyDef.ctrlKey || keyDef.metaKey)
        };
        if (key.length > 1) {
            normalizedDef.altKey = !!keyDef.altKey;
            normalizedDef.shiftKey = !!keyDef.shiftKey;
        }
        keyDefs[shortcut] = normalizedDef;
        return keyDefs;
    }, {});
}







const $d9a6e66050e7e1e4$var$getButtons = (buttonList)=>buttonList.map((classes)=>`<button type="button" class="%buttonClass% ${classes}" tabindex="-1"></button>`).join('');
var $d9a6e66050e7e1e4$export$2e2bcd8739ae039 = (0, $f505456f79607dba$export$2c0ac0b7971fd4b0)(`<div class="datepicker">
  <div class="datepicker-picker">
    <div class="datepicker-header">
      <div class="datepicker-title"></div>
      <div class="datepicker-controls">
        ${$d9a6e66050e7e1e4$var$getButtons([
    'prev-button prev-btn',
    'view-switch',
    'next-button next-btn'
])}
      </div>
    </div>
    <div class="datepicker-main"></div>
    <div class="datepicker-footer">
      <div class="datepicker-controls">
        ${$d9a6e66050e7e1e4$var$getButtons([
    'today-button today-btn',
    'clear-button clear-btn'
])}
      </div>
    </div>
  </div>
</div>`);






var $fe6e12e2321a86db$export$2e2bcd8739ae039 = (0, $f505456f79607dba$export$2c0ac0b7971fd4b0)(`<div class="days">
  <div class="days-of-week">${(0, $f505456f79607dba$export$99349abb93b944f0)('span', 7, {
    class: 'dow'
})}</div>
  <div class="datepicker-grid">${(0, $f505456f79607dba$export$99349abb93b944f0)('span', 42)}</div>
</div>`);



var $2c50261487358479$export$2e2bcd8739ae039 = (0, $f505456f79607dba$export$2c0ac0b7971fd4b0)(`<div class="week-numbers calendar-weeks">
  <div class="days-of-week"><span class="dow"></span></div>
  <div class="weeks">${(0, $f505456f79607dba$export$99349abb93b944f0)('span', 6, {
    class: 'week'
})}</div>
</div>`);




class $1c38645811228aa9$export$2e2bcd8739ae039 {
    init(options) {
        if ('pickLevel' in options) this.isMinView = this.id === options.pickLevel;
        this.setOptions(options);
        this.updateFocus();
        this.updateSelection();
    }
    prepareForRender(switchLabel, prevButtonDisabled, nextButtonDisabled) {
        // refresh disabled years on every render in order to clear the ones added
        // by beforeShow hook at previous render
        this.disabled = [];
        const picker = this.picker;
        picker.setViewSwitchLabel(switchLabel);
        picker.setPrevButtonDisabled(prevButtonDisabled);
        picker.setNextButtonDisabled(nextButtonDisabled);
    }
    setDisabled(date, classList) {
        classList.add('disabled');
        (0, $f505456f79607dba$export$e91d9f829d98c173)(this.disabled, date);
    }
    // Execute beforeShow() callback and apply the result to the element
    // args:
    performBeforeHook(el, timeValue) {
        let result = this.beforeShow(new Date(timeValue));
        switch(typeof result){
            case 'boolean':
                result = {
                    enabled: result
                };
                break;
            case 'string':
                result = {
                    classes: result
                };
        }
        if (result) {
            const classList = el.classList;
            if (result.enabled === false) this.setDisabled(timeValue, classList);
            if (result.classes) {
                const extraClasses = result.classes.split(/\s+/);
                classList.add(...extraClasses);
                if (extraClasses.includes('disabled')) this.setDisabled(timeValue, classList);
            }
            if (result.content) (0, $f211e3b999ad01fd$export$6ee6eabb13f4dce8)(el, result.content);
        }
    }
    renderCell(el, content, cellVal, date, { selected: selected, range: range }, outOfScope, extraClasses = []) {
        el.textContent = content;
        if (this.isMinView) el.dataset.date = date;
        const classList = el.classList;
        el.className = `datepicker-cell ${this.cellClass}`;
        if (cellVal < this.first) classList.add('prev');
        else if (cellVal > this.last) classList.add('next');
        classList.add(...extraClasses);
        if (outOfScope || this.checkDisabled(date, this.id)) this.setDisabled(date, classList);
        if (range) {
            const [rangeStart, rangeEnd] = range;
            if (cellVal > rangeStart && cellVal < rangeEnd) classList.add('range');
            if (cellVal === rangeStart) classList.add('range-start');
            if (cellVal === rangeEnd) classList.add('range-end');
        }
        if (selected.includes(cellVal)) classList.add('selected');
        if (cellVal === this.focused) classList.add('focused');
        if (this.beforeShow) this.performBeforeHook(el, date);
    }
    refreshCell(el, cellVal, selected, [rangeStart, rangeEnd]) {
        const classList = el.classList;
        classList.remove('range', 'range-start', 'range-end', 'selected', 'focused');
        if (cellVal > rangeStart && cellVal < rangeEnd) classList.add('range');
        if (cellVal === rangeStart) classList.add('range-start');
        if (cellVal === rangeEnd) classList.add('range-end');
        if (selected.includes(cellVal)) classList.add('selected');
        if (cellVal === this.focused) classList.add('focused');
    }
    changeFocusedCell(cellIndex) {
        this.grid.querySelectorAll('.focused').forEach((el)=>{
            el.classList.remove('focused');
        });
        this.grid.children[cellIndex].classList.add('focused');
    }
    constructor(picker, config){
        Object.assign(this, config, {
            picker: picker,
            element: (0, $f211e3b999ad01fd$export$8a49393be2d55148)(`<div class="datepicker-view"></div>`).firstChild,
            selected: [],
            isRangeEnd: !!picker.datepicker.rangeSideIndex
        });
        this.init(this.picker.datepicker.config);
    }
}


class $04d9c64a5b4e89b8$export$2e2bcd8739ae039 extends (0, $1c38645811228aa9$export$2e2bcd8739ae039) {
    init(options, onConstruction = true) {
        if (onConstruction) {
            const inner = (0, $f211e3b999ad01fd$export$8a49393be2d55148)((0, $fe6e12e2321a86db$export$2e2bcd8739ae039)).firstChild;
            this.dow = inner.firstChild;
            this.grid = inner.lastChild;
            this.element.appendChild(inner);
        }
        super.init(options);
    }
    setOptions(options) {
        let updateDOW;
        if ('minDate' in options) this.minDate = options.minDate;
        if ('maxDate' in options) this.maxDate = options.maxDate;
        if (options.checkDisabled) this.checkDisabled = options.checkDisabled;
        if (options.daysOfWeekDisabled) {
            this.daysOfWeekDisabled = options.daysOfWeekDisabled;
            updateDOW = true;
        }
        if (options.daysOfWeekHighlighted) this.daysOfWeekHighlighted = options.daysOfWeekHighlighted;
        if ('todayHighlight' in options) this.todayHighlight = options.todayHighlight;
        if ('weekStart' in options) {
            this.weekStart = options.weekStart;
            this.weekEnd = options.weekEnd;
            updateDOW = true;
        }
        if (options.locale) {
            const locale = this.locale = options.locale;
            this.dayNames = locale.daysMin;
            this.switchLabelFormat = locale.titleFormat;
            updateDOW = true;
        }
        if ('beforeShowDay' in options) this.beforeShow = typeof options.beforeShowDay === 'function' ? options.beforeShowDay : undefined;
        if ('weekNumbers' in options) {
            if (options.weekNumbers && !this.weekNumbers) {
                const weeksElem = (0, $f211e3b999ad01fd$export$8a49393be2d55148)((0, $2c50261487358479$export$2e2bcd8739ae039)).firstChild;
                this.weekNumbers = {
                    element: weeksElem,
                    dow: weeksElem.firstChild,
                    weeks: weeksElem.lastChild
                };
                this.element.insertBefore(weeksElem, this.element.firstChild);
            } else if (this.weekNumbers && !options.weekNumbers) {
                this.element.removeChild(this.weekNumbers.element);
                this.weekNumbers = null;
            }
        }
        if ('getWeekNumber' in options) this.getWeekNumber = options.getWeekNumber;
        if ('showDaysOfWeek' in options) {
            if (options.showDaysOfWeek) {
                (0, $f211e3b999ad01fd$export$998191bfdf710c72)(this.dow);
                if (this.weekNumbers) (0, $f211e3b999ad01fd$export$998191bfdf710c72)(this.weekNumbers.dow);
            } else {
                (0, $f211e3b999ad01fd$export$7669482c90f5c50f)(this.dow);
                if (this.weekNumbers) (0, $f211e3b999ad01fd$export$7669482c90f5c50f)(this.weekNumbers.dow);
            }
        }
        // update days-of-week when locale, daysOfweekDisabled or weekStart is changed
        if (updateDOW) Array.from(this.dow.children).forEach((el, index)=>{
            const dow = (this.weekStart + index) % 7;
            el.textContent = this.dayNames[dow];
            el.className = this.daysOfWeekDisabled.includes(dow) ? 'dow disabled' : 'dow';
        });
    }
    // Apply update on the focused date to view's settings
    updateFocus() {
        const viewDate = new Date(this.picker.viewDate);
        const viewYear = viewDate.getFullYear();
        const viewMonth = viewDate.getMonth();
        const firstOfMonth = (0, $0ff2c8d69c31afd2$export$63afb81dba78b33e)(viewYear, viewMonth, 1);
        const start = (0, $0ff2c8d69c31afd2$export$2107381f343b93b3)(firstOfMonth, this.weekStart, this.weekStart);
        this.first = firstOfMonth;
        this.last = (0, $0ff2c8d69c31afd2$export$63afb81dba78b33e)(viewYear, viewMonth + 1, 0);
        this.start = start;
        this.focused = this.picker.viewDate;
    }
    // Apply update on the selected dates to view's settings
    updateSelection() {
        const { dates: dates, rangepicker: rangepicker } = this.picker.datepicker;
        this.selected = dates;
        if (rangepicker) this.range = rangepicker.dates;
    }
    // Update the entire view UI
    render() {
        // update today marker on ever render
        this.today = this.todayHighlight ? (0, $0ff2c8d69c31afd2$export$d0bdf45af03a6ea3)() : undefined;
        this.prepareForRender((0, $a2e8904b6110f6c8$export$3ae94a2503e890a1)(this.focused, this.switchLabelFormat, this.locale), this.first <= this.minDate, this.last >= this.maxDate);
        if (this.weekNumbers) {
            const weekStart = this.weekStart;
            const startOfWeek = (0, $0ff2c8d69c31afd2$export$2107381f343b93b3)(this.first, weekStart, weekStart);
            Array.from(this.weekNumbers.weeks.children).forEach((el, index)=>{
                const dateOfWeekStart = (0, $0ff2c8d69c31afd2$export$ef501a2bb4f3ee6b)(startOfWeek, index);
                el.textContent = this.getWeekNumber(dateOfWeekStart, weekStart);
                if (index > 3) el.classList[dateOfWeekStart > this.last ? 'add' : 'remove']('next');
            });
        }
        Array.from(this.grid.children).forEach((el, index)=>{
            const current = (0, $0ff2c8d69c31afd2$export$dd412b56f1e4d8aa)(this.start, index);
            const dateObj = new Date(current);
            const day = dateObj.getDay();
            const extraClasses = [];
            if (this.today === current) extraClasses.push('today');
            if (this.daysOfWeekHighlighted.includes(day)) extraClasses.push('highlighted');
            this.renderCell(el, dateObj.getDate(), current, current, this, current < this.minDate || current > this.maxDate || this.daysOfWeekDisabled.includes(day), extraClasses);
        });
    }
    // Update the view UI by applying the changes of selected and focused items
    refresh() {
        const range = this.range || [];
        Array.from(this.grid.children).forEach((el)=>{
            this.refreshCell(el, Number(el.dataset.date), this.selected, range);
        });
    }
    // Update the view UI by applying the change of focused item
    refreshFocus() {
        this.changeFocusedCell(Math.round((this.focused - this.start) / 86400000));
    }
    constructor(picker){
        super(picker, {
            id: 0,
            name: 'days',
            cellClass: 'day'
        });
    }
}






function $e05ef2b3a4887458$var$computeMonthRange(range, thisYear) {
    if (!range || !range[0] || !range[1]) return;
    const [[startY, startM], [endY, endM]] = range;
    if (startY > thisYear || endY < thisYear) return;
    return [
        startY === thisYear ? startM : -1,
        endY === thisYear ? endM : 12
    ];
}
class $e05ef2b3a4887458$export$2e2bcd8739ae039 extends (0, $1c38645811228aa9$export$2e2bcd8739ae039) {
    init(options, onConstruction = true) {
        if (onConstruction) {
            this.grid = this.element;
            this.element.classList.add('months', 'datepicker-grid');
            this.grid.appendChild((0, $f211e3b999ad01fd$export$8a49393be2d55148)((0, $f505456f79607dba$export$99349abb93b944f0)('span', 12, {
                'data-month': (ix)=>ix
            })));
            this.first = 0;
            this.last = 11;
        }
        super.init(options);
    }
    setOptions(options) {
        if (options.locale) this.monthNames = options.locale.monthsShort;
        if ('minDate' in options) {
            if (options.minDate === undefined) this.minYear = this.minMonth = this.minDate = undefined;
            else {
                const minDateObj = new Date(options.minDate);
                this.minYear = minDateObj.getFullYear();
                this.minMonth = minDateObj.getMonth();
                this.minDate = minDateObj.setDate(1);
            }
        }
        if ('maxDate' in options) {
            if (options.maxDate === undefined) this.maxYear = this.maxMonth = this.maxDate = undefined;
            else {
                const maxDateObj = new Date(options.maxDate);
                this.maxYear = maxDateObj.getFullYear();
                this.maxMonth = maxDateObj.getMonth();
                this.maxDate = (0, $0ff2c8d69c31afd2$export$63afb81dba78b33e)(this.maxYear, this.maxMonth + 1, 0);
            }
        }
        if (options.checkDisabled) this.checkDisabled = this.isMinView || options.datesDisabled === null ? options.checkDisabled : ()=>false;
        if ('beforeShowMonth' in options) this.beforeShow = typeof options.beforeShowMonth === 'function' ? options.beforeShowMonth : undefined;
    }
    // Update view's settings to reflect the viewDate set on the picker
    updateFocus() {
        const viewDate = new Date(this.picker.viewDate);
        this.year = viewDate.getFullYear();
        this.focused = viewDate.getMonth();
    }
    // Update view's settings to reflect the selected dates
    updateSelection() {
        const { dates: dates, rangepicker: rangepicker } = this.picker.datepicker;
        this.selected = dates.reduce((selected, timeValue)=>{
            const date = new Date(timeValue);
            const year = date.getFullYear();
            const month = date.getMonth();
            if (selected[year] === undefined) selected[year] = [
                month
            ];
            else (0, $f505456f79607dba$export$e91d9f829d98c173)(selected[year], month);
            return selected;
        }, {});
        if (rangepicker && rangepicker.dates) this.range = rangepicker.dates.map((timeValue)=>{
            const date = new Date(timeValue);
            return isNaN(date) ? undefined : [
                date.getFullYear(),
                date.getMonth()
            ];
        });
    }
    // Update the entire view UI
    render() {
        this.prepareForRender(this.year, this.year <= this.minYear, this.year >= this.maxYear);
        const selected = this.selected[this.year] || [];
        const yrOutOfRange = this.year < this.minYear || this.year > this.maxYear;
        const isMinYear = this.year === this.minYear;
        const isMaxYear = this.year === this.maxYear;
        const range = $e05ef2b3a4887458$var$computeMonthRange(this.range, this.year);
        Array.from(this.grid.children).forEach((el, index)=>{
            const date = (0, $0ff2c8d69c31afd2$export$5327a72746f6632f)(new Date(this.year, index, 1), 1, this.isRangeEnd);
            this.renderCell(el, this.monthNames[index], index, date, {
                selected: selected,
                range: range
            }, yrOutOfRange || isMinYear && index < this.minMonth || isMaxYear && index > this.maxMonth);
        });
    }
    // Update the view UI by applying the changes of selected and focused items
    refresh() {
        const selected = this.selected[this.year] || [];
        const range = $e05ef2b3a4887458$var$computeMonthRange(this.range, this.year) || [];
        Array.from(this.grid.children).forEach((el, index)=>{
            this.refreshCell(el, index, selected, range);
        });
    }
    // Update the view UI by applying the change of focused item
    refreshFocus() {
        this.changeFocusedCell(this.focused);
    }
    constructor(picker){
        super(picker, {
            id: 1,
            name: 'months',
            cellClass: 'month'
        });
    }
}






function $63d5091b85f8b952$var$toTitleCase(word) {
    return [
        ...word
    ].reduce((str, ch, ix)=>str += ix ? ch : ch.toUpperCase(), '');
}
class $63d5091b85f8b952$export$2e2bcd8739ae039 extends (0, $1c38645811228aa9$export$2e2bcd8739ae039) {
    init(options, onConstruction = true) {
        if (onConstruction) {
            this.navStep = this.step * 10;
            this.beforeShowOption = `beforeShow${$63d5091b85f8b952$var$toTitleCase(this.cellClass)}`;
            this.grid = this.element;
            this.element.classList.add(this.name, 'datepicker-grid');
            this.grid.appendChild((0, $f211e3b999ad01fd$export$8a49393be2d55148)((0, $f505456f79607dba$export$99349abb93b944f0)('span', 12)));
        }
        super.init(options);
    }
    setOptions(options) {
        if ('minDate' in options) {
            if (options.minDate === undefined) this.minYear = this.minDate = undefined;
            else {
                this.minYear = (0, $0ff2c8d69c31afd2$export$30a149176b338f53)(options.minDate, this.step);
                this.minDate = (0, $0ff2c8d69c31afd2$export$63afb81dba78b33e)(this.minYear, 0, 1);
            }
        }
        if ('maxDate' in options) {
            if (options.maxDate === undefined) this.maxYear = this.maxDate = undefined;
            else {
                this.maxYear = (0, $0ff2c8d69c31afd2$export$30a149176b338f53)(options.maxDate, this.step);
                this.maxDate = (0, $0ff2c8d69c31afd2$export$63afb81dba78b33e)(this.maxYear, 11, 31);
            }
        }
        if (options.checkDisabled) this.checkDisabled = this.isMinView || options.datesDisabled === null ? options.checkDisabled : ()=>false;
        if (this.beforeShowOption in options) {
            const beforeShow = options[this.beforeShowOption];
            this.beforeShow = typeof beforeShow === 'function' ? beforeShow : undefined;
        }
    }
    // Update view's settings to reflect the viewDate set on the picker
    updateFocus() {
        const viewDate = new Date(this.picker.viewDate);
        const first = (0, $0ff2c8d69c31afd2$export$30a149176b338f53)(viewDate, this.navStep);
        const last = first + 9 * this.step;
        this.first = first;
        this.last = last;
        this.start = first - this.step;
        this.focused = (0, $0ff2c8d69c31afd2$export$30a149176b338f53)(viewDate, this.step);
    }
    // Update view's settings to reflect the selected dates
    updateSelection() {
        const { dates: dates, rangepicker: rangepicker } = this.picker.datepicker;
        this.selected = dates.reduce((years, timeValue)=>{
            return (0, $f505456f79607dba$export$e91d9f829d98c173)(years, (0, $0ff2c8d69c31afd2$export$30a149176b338f53)(timeValue, this.step));
        }, []);
        if (rangepicker && rangepicker.dates) this.range = rangepicker.dates.map((timeValue)=>{
            if (timeValue !== undefined) return (0, $0ff2c8d69c31afd2$export$30a149176b338f53)(timeValue, this.step);
        });
    }
    // Update the entire view UI
    render() {
        this.prepareForRender(`${this.first}-${this.last}`, this.first <= this.minYear, this.last >= this.maxYear);
        Array.from(this.grid.children).forEach((el, index)=>{
            const current = this.start + index * this.step;
            const date = (0, $0ff2c8d69c31afd2$export$5327a72746f6632f)(new Date(current, 0, 1), 2, this.isRangeEnd);
            el.dataset.year = current;
            this.renderCell(el, current, current, date, this, current < this.minYear || current > this.maxYear);
        });
    }
    // Update the view UI by applying the changes of selected and focused items
    refresh() {
        const range = this.range || [];
        Array.from(this.grid.children).forEach((el)=>{
            this.refreshCell(el, Number(el.textContent), this.selected, range);
        });
    }
    // Update the view UI by applying the change of focused item
    refreshFocus() {
        this.changeFocusedCell(Math.round((this.focused - this.start) / this.step));
    }
    constructor(picker, config){
        super(picker, config);
    }
}





function $96505fde85a4922e$export$a47b069c9344a2f1(datepicker, type) {
    const options = {
        bubbles: true,
        cancelable: true,
        detail: {
            date: datepicker.getDate(),
            viewDate: new Date(datepicker.picker.viewDate),
            viewId: datepicker.picker.currentView.id,
            datepicker: datepicker
        }
    };
    datepicker.element.dispatchEvent(new CustomEvent(type, options));
}
function $96505fde85a4922e$export$34ebb93ceb1e72c9(datepicker, direction) {
    const { config: config, picker: picker } = datepicker;
    const { currentView: currentView, viewDate: viewDate } = picker;
    let newViewDate;
    switch(currentView.id){
        case 0:
            newViewDate = (0, $0ff2c8d69c31afd2$export$17c93e242b2d3a22)(viewDate, direction);
            break;
        case 1:
            newViewDate = (0, $0ff2c8d69c31afd2$export$3d83eec43f4ea476)(viewDate, direction);
            break;
        default:
            newViewDate = (0, $0ff2c8d69c31afd2$export$3d83eec43f4ea476)(viewDate, direction * currentView.navStep);
    }
    newViewDate = (0, $f505456f79607dba$export$c6630e295fcd125)(newViewDate, config.minDate, config.maxDate);
    picker.changeFocus(newViewDate).render();
}
function $96505fde85a4922e$export$adaf8a367aa41030(datepicker) {
    const viewId = datepicker.picker.currentView.id;
    if (viewId === datepicker.config.maxView) return;
    datepicker.picker.changeView(viewId + 1).render();
}
function $96505fde85a4922e$export$a3d02541b0ebf605(datepicker) {
    datepicker.setDate({
        clear: true
    });
}
function $96505fde85a4922e$export$3a1f057a5603f01b(datepicker) {
    const currentDate = (0, $0ff2c8d69c31afd2$export$d0bdf45af03a6ea3)();
    if (datepicker.config.todayButtonMode === 1) datepicker.setDate(currentDate, {
        forceRefresh: true,
        viewDate: currentDate
    });
    else datepicker.setFocusedDate(currentDate, true);
}
function $96505fde85a4922e$export$cf56467fba10557d(datepicker) {
    const onBlur = ()=>{
        if (datepicker.config.updateOnBlur) datepicker.update({
            revert: true
        });
        else datepicker.refresh('input');
        datepicker.hide();
    };
    const element = datepicker.element;
    if ((0, $f211e3b999ad01fd$export$8a2eb51c14bb8899)(element)) element.addEventListener('blur', onBlur, {
        once: true
    });
    else onBlur();
}





function $9d11603db6227498$var$goToSelectedMonthOrYear(datepicker, selection) {
    const picker = datepicker.picker;
    const viewDate = new Date(picker.viewDate);
    const viewId = picker.currentView.id;
    const newDate = viewId === 1 ? (0, $0ff2c8d69c31afd2$export$17c93e242b2d3a22)(viewDate, selection - viewDate.getMonth()) : (0, $0ff2c8d69c31afd2$export$3d83eec43f4ea476)(viewDate, selection - viewDate.getFullYear());
    picker.changeFocus(newDate).changeView(viewId - 1).render();
}
function $9d11603db6227498$export$8e4624f1a67770a2(datepicker) {
    (0, $96505fde85a4922e$export$adaf8a367aa41030)(datepicker);
}
function $9d11603db6227498$export$2e00206ae75d43c2(datepicker) {
    (0, $96505fde85a4922e$export$34ebb93ceb1e72c9)(datepicker, -1);
}
function $9d11603db6227498$export$3c7a15f232d71472(datepicker) {
    (0, $96505fde85a4922e$export$34ebb93ceb1e72c9)(datepicker, 1);
}
function $9d11603db6227498$export$aae1c84f767d63c0(datepicker, ev) {
    const target = (0, $7d9bfbde81d6cbf0$export$f0be97bc7a4f9c42)(ev, '.datepicker-cell');
    if (!target || target.classList.contains('disabled')) return;
    const { id: id, isMinView: isMinView } = datepicker.picker.currentView;
    const data = target.dataset;
    if (isMinView) datepicker.setDate(Number(data.date));
    else if (id === 1) $9d11603db6227498$var$goToSelectedMonthOrYear(datepicker, Number(data.month));
    else $9d11603db6227498$var$goToSelectedMonthOrYear(datepicker, Number(data.year));
}
function $9d11603db6227498$export$72f1d25551f0a150(ev) {
    ev.preventDefault();
}


const $351a502eef50e15d$var$orientClasses = [
    'left',
    'top',
    'right',
    'bottom'
].reduce((obj, key)=>{
    obj[key] = `datepicker-orient-${key}`;
    return obj;
}, {});
const $351a502eef50e15d$var$toPx = (num)=>num ? `${num}px` : num;
function $351a502eef50e15d$var$processPickerOptions(picker, options) {
    if ('title' in options) {
        if (options.title) {
            picker.controls.title.textContent = options.title;
            (0, $f211e3b999ad01fd$export$998191bfdf710c72)(picker.controls.title);
        } else {
            picker.controls.title.textContent = '';
            (0, $f211e3b999ad01fd$export$7669482c90f5c50f)(picker.controls.title);
        }
    }
    if (options.prevArrow) {
        const prevButton = picker.controls.prevButton;
        (0, $f211e3b999ad01fd$export$8ef79934f06defab)(prevButton);
        options.prevArrow.forEach((node)=>{
            prevButton.appendChild(node.cloneNode(true));
        });
    }
    if (options.nextArrow) {
        const nextButton = picker.controls.nextButton;
        (0, $f211e3b999ad01fd$export$8ef79934f06defab)(nextButton);
        options.nextArrow.forEach((node)=>{
            nextButton.appendChild(node.cloneNode(true));
        });
    }
    if (options.locale) {
        picker.controls.todayButton.textContent = options.locale.today;
        picker.controls.clearButton.textContent = options.locale.clear;
    }
    if ('todayButton' in options) {
        if (options.todayButton) (0, $f211e3b999ad01fd$export$998191bfdf710c72)(picker.controls.todayButton);
        else (0, $f211e3b999ad01fd$export$7669482c90f5c50f)(picker.controls.todayButton);
    }
    if ('minDate' in options || 'maxDate' in options) {
        const { minDate: minDate, maxDate: maxDate } = picker.datepicker.config;
        picker.controls.todayButton.disabled = !(0, $f505456f79607dba$export$6dabbcb26357acf4)((0, $0ff2c8d69c31afd2$export$d0bdf45af03a6ea3)(), minDate, maxDate);
    }
    if ('clearButton' in options) {
        if (options.clearButton) (0, $f211e3b999ad01fd$export$998191bfdf710c72)(picker.controls.clearButton);
        else (0, $f211e3b999ad01fd$export$7669482c90f5c50f)(picker.controls.clearButton);
    }
}
// Compute view date to reset, which will be...
// - the last item of the selected dates or defaultViewDate if no selection
// - limited to minDate or maxDate if it exceeds the range
function $351a502eef50e15d$var$computeResetViewDate(datepicker) {
    const { dates: dates, config: config, rangeSideIndex: rangeSideIndex } = datepicker;
    const viewDate = dates.length > 0 ? (0, $f505456f79607dba$export$60b8b41c1898ab89)(dates) : (0, $0ff2c8d69c31afd2$export$5327a72746f6632f)(config.defaultViewDate, config.pickLevel, rangeSideIndex);
    return (0, $f505456f79607dba$export$c6630e295fcd125)(viewDate, config.minDate, config.maxDate);
}
// Change current view's view date
function $351a502eef50e15d$var$setViewDate(picker, newDate) {
    if (!('_oldViewDate' in picker) && newDate !== picker.viewDate) picker._oldViewDate = picker.viewDate;
    picker.viewDate = newDate;
    // return whether the new date is in different period on time from the one
    // displayed in the current view
    // when true, the view needs to be re-rendered on the next UI refresh.
    const { id: id, year: year, first: first, last: last } = picker.currentView;
    const viewYear = new Date(newDate).getFullYear();
    switch(id){
        case 0:
            return newDate < first || newDate > last;
        case 1:
            return viewYear !== year;
        default:
            return viewYear < first || viewYear > last;
    }
}
function $351a502eef50e15d$var$getTextDirection(el) {
    return window.getComputedStyle(el).direction;
}
// find the closet scrollable ancestor element under the body
function $351a502eef50e15d$var$findScrollParents(el) {
    const parent = (0, $f211e3b999ad01fd$export$58081aedf094d85b)(el);
    if (parent === document.body || !parent) return;
    // checking overflow only is enough because computed overflow cannot be
    // visible or a combination of visible and other when either axis is set
    // to other than visible.
    // (Setting one axis to other than 'visible' while the other is 'visible'
    // results in the other axis turning to 'auto')
    return window.getComputedStyle(parent).overflow !== 'visible' ? parent : $351a502eef50e15d$var$findScrollParents(parent);
}
class $351a502eef50e15d$export$2e2bcd8739ae039 {
    setOptions(options) {
        $351a502eef50e15d$var$processPickerOptions(this, options);
        this.views.forEach((view)=>{
            view.init(options, false);
        });
        this.currentView.render();
    }
    detach() {
        this.element.remove();
    }
    show() {
        if (this.active) return;
        const { datepicker: datepicker, element: element } = this;
        const inputField = datepicker.inputField;
        if (inputField) {
            // ensure picker's direction matches input's
            const inputDirection = $351a502eef50e15d$var$getTextDirection(inputField);
            if (inputDirection !== $351a502eef50e15d$var$getTextDirection((0, $f211e3b999ad01fd$export$58081aedf094d85b)(element))) element.dir = inputDirection;
            else if (element.dir) element.removeAttribute('dir');
            // Determine the picker's position first to prevent `orientation: 'auto'`
            // from being miscalculated to 'bottom' after the picker temporarily
            // shown below the input field expands the document height if the field
            // is at the bottom edge of the document
            this.place();
            element.classList.add('active');
            if (datepicker.config.disableTouchKeyboard) inputField.blur();
        } else element.classList.add('active');
        this.active = true;
        (0, $96505fde85a4922e$export$a47b069c9344a2f1)(datepicker, 'show');
    }
    hide() {
        if (!this.active) return;
        this.datepicker.exitEditMode();
        this.element.classList.remove('active');
        this.active = false;
        (0, $96505fde85a4922e$export$a47b069c9344a2f1)(this.datepicker, 'hide');
    }
    place() {
        const { classList: classList, style: style } = this.element;
        // temporarily display the picker to get its size and offset parent
        style.display = 'block';
        const { width: calendarWidth, height: calendarHeight } = this.element.getBoundingClientRect();
        const offsetParent = this.element.offsetParent;
        // turn the picker back to hidden so that the position is determined with
        // the state before it is shown.
        style.display = '';
        const { config: config, inputField: inputField } = this.datepicker;
        const { left: inputLeft, top: inputTop, right: inputRight, bottom: inputBottom, width: inputWidth, height: inputHeight } = inputField.getBoundingClientRect();
        let { x: orientX, y: orientY } = config.orientation;
        let left = inputLeft;
        let top = inputTop;
        // caliculate offsetLeft/Top of inputField
        if (offsetParent === document.body || !offsetParent) {
            left += window.scrollX;
            top += window.scrollY;
        } else {
            const offsetParentRect = offsetParent.getBoundingClientRect();
            left -= offsetParentRect.left - offsetParent.scrollLeft;
            top -= offsetParentRect.top - offsetParent.scrollTop;
        }
        // caliculate the boundaries of the visible area that contains inputField
        const scrollParent = $351a502eef50e15d$var$findScrollParents(inputField);
        let scrollAreaLeft = 0;
        let scrollAreaTop = 0;
        let { clientWidth: scrollAreaRight, clientHeight: scrollAreaBottom } = document.documentElement;
        if (scrollParent) {
            const scrollParentRect = scrollParent.getBoundingClientRect();
            if (scrollParentRect.top > 0) scrollAreaTop = scrollParentRect.top;
            if (scrollParentRect.left > 0) scrollAreaLeft = scrollParentRect.left;
            if (scrollParentRect.right < scrollAreaRight) scrollAreaRight = scrollParentRect.right;
            if (scrollParentRect.bottom < scrollAreaBottom) scrollAreaBottom = scrollParentRect.bottom;
        }
        // determine the horizontal orientation and left position
        let adjustment = 0;
        if (orientX === 'auto') {
            if (inputLeft < scrollAreaLeft) {
                orientX = 'left';
                adjustment = scrollAreaLeft - inputLeft;
            } else if (inputLeft + calendarWidth > scrollAreaRight) {
                orientX = 'right';
                if (scrollAreaRight < inputRight) adjustment = scrollAreaRight - inputRight;
            } else if ($351a502eef50e15d$var$getTextDirection(inputField) === 'rtl') orientX = inputRight - calendarWidth < scrollAreaLeft ? 'left' : 'right';
            else orientX = 'left';
        }
        if (orientX === 'right') left += inputWidth - calendarWidth;
        left += adjustment;
        // determine the vertical orientation and top position
        if (orientY === 'auto') {
            if (inputTop - calendarHeight > scrollAreaTop) orientY = inputBottom + calendarHeight > scrollAreaBottom ? 'top' : 'bottom';
            else orientY = 'bottom';
        }
        if (orientY === 'top') top -= calendarHeight;
        else top += inputHeight;
        classList.remove(...Object.values($351a502eef50e15d$var$orientClasses));
        classList.add($351a502eef50e15d$var$orientClasses[orientX], $351a502eef50e15d$var$orientClasses[orientY]);
        style.left = $351a502eef50e15d$var$toPx(left);
        style.top = $351a502eef50e15d$var$toPx(top);
    }
    setViewSwitchLabel(labelText) {
        this.controls.viewSwitch.textContent = labelText;
    }
    setPrevButtonDisabled(disabled) {
        this.controls.prevButton.disabled = disabled;
    }
    setNextButtonDisabled(disabled) {
        this.controls.nextButton.disabled = disabled;
    }
    changeView(viewId) {
        const currentView = this.currentView;
        if (viewId !== currentView.id) {
            if (!this._oldView) this._oldView = currentView;
            this.currentView = this.views[viewId];
            this._renderMethod = 'render';
        }
        return this;
    }
    // Change the focused date (view date)
    changeFocus(newViewDate) {
        this._renderMethod = $351a502eef50e15d$var$setViewDate(this, newViewDate) ? 'render' : 'refreshFocus';
        this.views.forEach((view)=>{
            view.updateFocus();
        });
        return this;
    }
    // Apply the change of the selected dates
    update(viewDate) {
        const newViewDate = viewDate === undefined ? $351a502eef50e15d$var$computeResetViewDate(this.datepicker) : viewDate;
        this._renderMethod = $351a502eef50e15d$var$setViewDate(this, newViewDate) ? 'render' : 'refresh';
        this.views.forEach((view)=>{
            view.updateFocus();
            view.updateSelection();
        });
        return this;
    }
    // Refresh the picker UI
    render(quickRender = true) {
        const { currentView: currentView, datepicker: datepicker, _oldView: oldView } = this;
        const oldViewDate = new Date(this._oldViewDate);
        const renderMethod = quickRender && this._renderMethod || 'render';
        delete this._oldView;
        delete this._oldViewDate;
        delete this._renderMethod;
        currentView[renderMethod]();
        if (oldView) {
            this.main.replaceChild(currentView.element, oldView.element);
            (0, $96505fde85a4922e$export$a47b069c9344a2f1)(datepicker, 'changeView');
        }
        if (!isNaN(oldViewDate)) {
            const newViewDate = new Date(this.viewDate);
            if (newViewDate.getFullYear() !== oldViewDate.getFullYear()) (0, $96505fde85a4922e$export$a47b069c9344a2f1)(datepicker, 'changeYear');
            if (newViewDate.getMonth() !== oldViewDate.getMonth()) (0, $96505fde85a4922e$export$a47b069c9344a2f1)(datepicker, 'changeMonth');
        }
    }
    constructor(datepicker){
        const { config: config, inputField: inputField } = this.datepicker = datepicker;
        const template = (0, $d9a6e66050e7e1e4$export$2e2bcd8739ae039).replace(/%buttonClass%/g, config.buttonClass);
        const element = this.element = (0, $f211e3b999ad01fd$export$8a49393be2d55148)(template).firstChild;
        const [header, main, footer] = element.firstChild.children;
        const title = header.firstElementChild;
        const [prevButton, viewSwitch, nextButton] = header.lastElementChild.children;
        const [todayButton, clearButton] = footer.firstChild.children;
        const controls = {
            title: title,
            prevButton: prevButton,
            viewSwitch: viewSwitch,
            nextButton: nextButton,
            todayButton: todayButton,
            clearButton: clearButton
        };
        this.main = main;
        this.controls = controls;
        const elementClass = inputField ? 'dropdown' : 'inline';
        element.classList.add(`datepicker-${elementClass}`);
        $351a502eef50e15d$var$processPickerOptions(this, config);
        this.viewDate = $351a502eef50e15d$var$computeResetViewDate(datepicker);
        // set up event listeners
        (0, $7d9bfbde81d6cbf0$export$ff47556151e281cc)(datepicker, [
            [
                element,
                'mousedown',
                (0, $9d11603db6227498$export$72f1d25551f0a150)
            ],
            [
                main,
                'click',
                (0, $9d11603db6227498$export$aae1c84f767d63c0).bind(null, datepicker)
            ],
            [
                controls.viewSwitch,
                'click',
                (0, $9d11603db6227498$export$8e4624f1a67770a2).bind(null, datepicker)
            ],
            [
                controls.prevButton,
                'click',
                (0, $9d11603db6227498$export$2e00206ae75d43c2).bind(null, datepicker)
            ],
            [
                controls.nextButton,
                'click',
                (0, $9d11603db6227498$export$3c7a15f232d71472).bind(null, datepicker)
            ],
            [
                controls.todayButton,
                'click',
                (0, $96505fde85a4922e$export$3a1f057a5603f01b).bind(null, datepicker)
            ],
            [
                controls.clearButton,
                'click',
                (0, $96505fde85a4922e$export$a3d02541b0ebf605).bind(null, datepicker)
            ]
        ]);
        // set up views
        this.views = [
            new (0, $04d9c64a5b4e89b8$export$2e2bcd8739ae039)(this),
            new (0, $e05ef2b3a4887458$export$2e2bcd8739ae039)(this),
            new (0, $63d5091b85f8b952$export$2e2bcd8739ae039)(this, {
                id: 2,
                name: 'years',
                cellClass: 'year',
                step: 1
            }),
            new (0, $63d5091b85f8b952$export$2e2bcd8739ae039)(this, {
                id: 3,
                name: 'decades',
                cellClass: 'decade',
                step: 10
            })
        ];
        this.currentView = this.views[config.startView];
        this.currentView.render();
        this.main.appendChild(this.currentView.element);
        if (config.container) config.container.appendChild(this.element);
        else inputField.after(this.element);
    }
}







// Find the closest date that doesn't meet the condition for unavailable date
// Returns undefined if no available date is found
// addFn: function to calculate the next date
//   - args: time value, amount
// increase: amount to pass to addFn
// testFn: function to test the unavailability of the date
//   - args: time value; return: true if unavailable
function $c0f4f1bd39256c35$var$findNextAvailableOne(date, addFn, increase, testFn, min, max) {
    if (!(0, $f505456f79607dba$export$6dabbcb26357acf4)(date, min, max)) return;
    if (testFn(date)) {
        const newDate = addFn(date, increase);
        return $c0f4f1bd39256c35$var$findNextAvailableOne(newDate, addFn, increase, testFn, min, max);
    }
    return date;
}
// direction: -1 (left/up), 1 (right/down)
// vertical: true for up/down, false for left/right
function $c0f4f1bd39256c35$var$moveByArrowKey(datepicker, direction, vertical) {
    const picker = datepicker.picker;
    const currentView = picker.currentView;
    const step = currentView.step || 1;
    let viewDate = picker.viewDate;
    let addFn;
    switch(currentView.id){
        case 0:
            viewDate = (0, $0ff2c8d69c31afd2$export$dd412b56f1e4d8aa)(viewDate, vertical ? direction * 7 : direction);
            addFn = (0, $0ff2c8d69c31afd2$export$dd412b56f1e4d8aa);
            break;
        case 1:
            viewDate = (0, $0ff2c8d69c31afd2$export$17c93e242b2d3a22)(viewDate, vertical ? direction * 4 : direction);
            addFn = (0, $0ff2c8d69c31afd2$export$17c93e242b2d3a22);
            break;
        default:
            viewDate = (0, $0ff2c8d69c31afd2$export$3d83eec43f4ea476)(viewDate, direction * (vertical ? 4 : 1) * step);
            addFn = (0, $0ff2c8d69c31afd2$export$3d83eec43f4ea476);
    }
    viewDate = $c0f4f1bd39256c35$var$findNextAvailableOne(viewDate, addFn, direction < 0 ? -step : step, (date)=>currentView.disabled.includes(date), currentView.minDate, currentView.maxDate);
    if (viewDate !== undefined) picker.changeFocus(viewDate).render();
}
function $c0f4f1bd39256c35$export$4506a59cef813c8b(datepicker, ev) {
    const { config: config, picker: picker, editMode: editMode } = datepicker;
    const active = picker.active;
    const { key: key, altKey: altKey, shiftKey: shiftKey } = ev;
    const ctrlOrMetaKey = ev.ctrlKey || ev.metaKey;
    const cancelEvent = ()=>{
        ev.preventDefault();
        ev.stopPropagation();
    };
    // tab/enter keys should not be taken by shortcut keys
    if (key === 'Tab') {
        (0, $96505fde85a4922e$export$cf56467fba10557d)(datepicker);
        return;
    }
    if (key === 'Enter') {
        if (!active) datepicker.update();
        else if (editMode) datepicker.exitEditMode({
            update: true,
            autohide: config.autohide
        });
        else {
            const currentView = picker.currentView;
            if (currentView.isMinView) datepicker.setDate(picker.viewDate);
            else {
                picker.changeView(currentView.id - 1).render();
                cancelEvent();
            }
        }
        return;
    }
    const shortcutKeys = config.shortcutKeys;
    const keyInfo = {
        key: key,
        ctrlOrMetaKey: ctrlOrMetaKey,
        altKey: altKey,
        shiftKey: shiftKey
    };
    const shortcut = Object.keys(shortcutKeys).find((item)=>{
        const keyDef = shortcutKeys[item];
        return !Object.keys(keyDef).find((prop)=>keyDef[prop] !== keyInfo[prop]);
    });
    if (shortcut) {
        let action;
        if (shortcut === 'toggle') action = shortcut;
        else if (editMode) {
            if (shortcut === 'exitEditMode') action = shortcut;
        } else if (active) {
            if (shortcut === 'hide') action = shortcut;
            else if (shortcut === 'prevButton') action = [
                (0, $96505fde85a4922e$export$34ebb93ceb1e72c9),
                [
                    datepicker,
                    -1
                ]
            ];
            else if (shortcut === 'nextButton') action = [
                (0, $96505fde85a4922e$export$34ebb93ceb1e72c9),
                [
                    datepicker,
                    1
                ]
            ];
            else if (shortcut === 'viewSwitch') action = [
                (0, $96505fde85a4922e$export$adaf8a367aa41030),
                [
                    datepicker
                ]
            ];
            else if (config.clearButton && shortcut === 'clearButton') action = [
                (0, $96505fde85a4922e$export$a3d02541b0ebf605),
                [
                    datepicker
                ]
            ];
            else if (config.todayButton && shortcut === 'todayButton') action = [
                (0, $96505fde85a4922e$export$3a1f057a5603f01b),
                [
                    datepicker
                ]
            ];
        } else if (shortcut === 'show') action = shortcut;
        if (action) {
            if (Array.isArray(action)) action[0].apply(null, action[1]);
            else datepicker[action]();
            cancelEvent();
            return;
        }
    }
    // perform as a regular <input> when picker in hidden or in edit mode
    if (!active || editMode) return;
    const handleArrowKeyPress = (direction, vertical)=>{
        if (shiftKey || ctrlOrMetaKey || altKey) datepicker.enterEditMode();
        else {
            $c0f4f1bd39256c35$var$moveByArrowKey(datepicker, direction, vertical);
            ev.preventDefault();
        }
    };
    if (key === 'ArrowLeft') handleArrowKeyPress(-1, false);
    else if (key === 'ArrowRight') handleArrowKeyPress(1, false);
    else if (key === 'ArrowUp') handleArrowKeyPress(-1, true);
    else if (key === 'ArrowDown') handleArrowKeyPress(1, true);
    else if (key === 'Backspace' || key === 'Delete' || key && key.length === 1 && !ctrlOrMetaKey) datepicker.enterEditMode();
}
function $c0f4f1bd39256c35$export$ecf9bf35ad97eb74(datepicker) {
    if (datepicker.config.showOnFocus && !datepicker._showing) datepicker.show();
}
function $c0f4f1bd39256c35$export$39ad0b1f682358f9(datepicker, ev) {
    const el = ev.target;
    if (datepicker.picker.active || datepicker.config.showOnClick) {
        el._active = (0, $f211e3b999ad01fd$export$8a2eb51c14bb8899)(el);
        el._clicking = setTimeout(()=>{
            delete el._active;
            delete el._clicking;
        }, 2000);
    }
}
function $c0f4f1bd39256c35$export$c7705f5678ebdc61(datepicker, ev) {
    const el = ev.target;
    if (!el._clicking) return;
    clearTimeout(el._clicking);
    delete el._clicking;
    if (el._active) datepicker.enterEditMode();
    delete el._active;
    if (datepicker.config.showOnClick) datepicker.show();
}
function $c0f4f1bd39256c35$export$48aae1120b60938a(datepicker, ev) {
    if (ev.clipboardData.types.includes('text/plain')) datepicker.enterEditMode();
}





function $59f7e80e6f007ef4$export$806d9a98fb0e6fd0(datepicker, ev) {
    const { element: element, picker: picker } = datepicker;
    // check both picker's and input's activeness to make updateOnBlur work in
    // the cases where...
    // - picker is hidden by ESC key press → input stays focused
    // - input is unfocused by closing mobile keyboard → piker is kept shown
    if (!picker.active && !(0, $f211e3b999ad01fd$export$8a2eb51c14bb8899)(element)) return;
    const pickerElem = picker.element;
    if ((0, $7d9bfbde81d6cbf0$export$f0be97bc7a4f9c42)(ev, (el)=>el === element || el === pickerElem)) return;
    (0, $96505fde85a4922e$export$cf56467fba10557d)(datepicker);
}


function $540e774e7a459390$var$stringifyDates(dates, config) {
    return dates.map((dt)=>(0, $a2e8904b6110f6c8$export$3ae94a2503e890a1)(dt, config.format, config.locale)).join(config.dateDelimiter);
}
// parse input dates and create an array of time values for selection
// returns undefined if there are no valid dates in inputDates
// when origDates (current selection) is passed, the function works to mix
// the input dates into the current selection
function $540e774e7a459390$var$processInputDates(datepicker, inputDates, clear = false) {
    if (inputDates.length === 0) // empty input is considered valid unless origiDates is passed
    return clear ? [] : undefined;
    const { config: config, dates: origDates, rangeSideIndex: rangeSideIndex } = datepicker;
    const { pickLevel: pickLevel, maxNumberOfDates: maxNumberOfDates } = config;
    let newDates = inputDates.reduce((dates, dt)=>{
        let date = (0, $a2e8904b6110f6c8$export$6b862160d295c8e)(dt, config.format, config.locale);
        if (date === undefined) return dates;
        // adjust to 1st of the month/Jan 1st of the year
        // or to the last day of the monh/Dec 31st of the year if the datepicker
        // is the range-end picker of a rangepicker
        date = (0, $0ff2c8d69c31afd2$export$5327a72746f6632f)(date, pickLevel, rangeSideIndex);
        if ((0, $f505456f79607dba$export$6dabbcb26357acf4)(date, config.minDate, config.maxDate) && !dates.includes(date) && !config.checkDisabled(date, pickLevel) && (pickLevel > 0 || !config.daysOfWeekDisabled.includes(new Date(date).getDay()))) dates.push(date);
        return dates;
    }, []);
    if (newDates.length === 0) return;
    if (config.multidate && !clear) // get the synmetric difference between origDates and newDates
    newDates = newDates.reduce((dates, date)=>{
        if (!origDates.includes(date)) dates.push(date);
        return dates;
    }, origDates.filter((date)=>!newDates.includes(date)));
    // do length check always because user can input multiple dates regardless of the mode
    return maxNumberOfDates && newDates.length > maxNumberOfDates ? newDates.slice(maxNumberOfDates * -1) : newDates;
}
// refresh the UI elements
// modes: 1: input only, 2, picker only, 3 both
function $540e774e7a459390$var$refreshUI(datepicker, mode = 3, quickRender = true, viewDate) {
    const { config: config, picker: picker, inputField: inputField } = datepicker;
    if (mode & 2) {
        const newView = picker.active ? config.pickLevel : config.startView;
        picker.update(viewDate).changeView(newView).render(quickRender);
    }
    if (mode & 1 && inputField) inputField.value = $540e774e7a459390$var$stringifyDates(datepicker.dates, config);
}
function $540e774e7a459390$var$setDate(datepicker, inputDates, options) {
    const config = datepicker.config;
    let { clear: clear, render: render, autohide: autohide, revert: revert, forceRefresh: forceRefresh, viewDate: viewDate } = options;
    if (render === undefined) render = true;
    if (!render) autohide = forceRefresh = false;
    else if (autohide === undefined) autohide = config.autohide;
    viewDate = (0, $a2e8904b6110f6c8$export$6b862160d295c8e)(viewDate, config.format, config.locale);
    const newDates = $540e774e7a459390$var$processInputDates(datepicker, inputDates, clear);
    if (!newDates && !revert) return;
    if (newDates && newDates.toString() !== datepicker.dates.toString()) {
        datepicker.dates = newDates;
        $540e774e7a459390$var$refreshUI(datepicker, render ? 3 : 1, true, viewDate);
        (0, $96505fde85a4922e$export$a47b069c9344a2f1)(datepicker, 'changeDate');
    } else $540e774e7a459390$var$refreshUI(datepicker, forceRefresh ? 3 : 1, true, viewDate);
    if (autohide) datepicker.hide();
}
function $540e774e7a459390$var$getOutputConverter(datepicker, format) {
    return format ? (date)=>(0, $a2e8904b6110f6c8$export$3ae94a2503e890a1)(date, format, datepicker.config.locale) : (date)=>new Date(date);
}
class $540e774e7a459390$export$2e2bcd8739ae039 {
    /**
   * Format Date object or time value in given format and language
   * @param  {Date|Number} date - date or time value to format
   * @param  {String|Object} format - format string or object that contains
   * toDisplay() custom formatter, whose signature is
   * - args:
   *   - date: {Date} - Date instance of the date passed to the method
   *   - format: {Object} - the format object passed to the method
   *   - locale: {Object} - locale for the language specified by `lang`
   * - return:
   *     {String} formatted date
   * @param  {String} [lang=en] - language code for the locale to use
   * @return {String} formatted date
   */ static formatDate(date, format, lang) {
        return (0, $a2e8904b6110f6c8$export$3ae94a2503e890a1)(date, format, lang && (0, $5f079e194dccbfe3$export$2e2bcd8739ae039)[lang] || (0, $5f079e194dccbfe3$export$2e2bcd8739ae039).en);
    }
    /**
   * Parse date string
   * @param  {String|Date|Number} dateStr - date string, Date object or time
   * value to parse
   * @param  {String|Object} format - format string or object that contains
   * toValue() custom parser, whose signature is
   * - args:
   *   - dateStr: {String|Date|Number} - the dateStr passed to the method
   *   - format: {Object} - the format object passed to the method
   *   - locale: {Object} - locale for the language specified by `lang`
   * - return:
   *     {Date|Number} parsed date or its time value
   * @param  {String} [lang=en] - language code for the locale to use
   * @return {Number} time value of parsed date
   */ static parseDate(dateStr, format, lang) {
        return (0, $a2e8904b6110f6c8$export$6b862160d295c8e)(dateStr, format, lang && (0, $5f079e194dccbfe3$export$2e2bcd8739ae039)[lang] || (0, $5f079e194dccbfe3$export$2e2bcd8739ae039).en);
    }
    /**
   * @type {Object} - Installed locales in `[languageCode]: localeObject` format
   * en`:_English (US)_ is pre-installed.
   */ static get locales() {
        return 0, $5f079e194dccbfe3$export$2e2bcd8739ae039;
    }
    /**
   * @type {Boolean} - Whether the picker element is shown. `true` when shown
   */ get active() {
        return !!(this.picker && this.picker.active);
    }
    /**
   * @type {HTMLDivElement} - DOM object of picker element
   */ get pickerElement() {
        return this.picker ? this.picker.element : undefined;
    }
    /**
   * Set new values to the config options
   * @param {Object} options - config options to update
   */ setOptions(options) {
        const newOptions = (0, $6dc6fcbfb2ef5738$export$2e2bcd8739ae039)(options, this);
        Object.assign(this._options, options);
        Object.assign(this.config, newOptions);
        this.picker.setOptions(newOptions);
        $540e774e7a459390$var$refreshUI(this, 3);
    }
    /**
   * Show the picker element
   */ show() {
        if (this.inputField) {
            const { config: config, inputField: inputField } = this;
            if (inputField.disabled || inputField.readOnly && !config.enableOnReadonly) return;
            if (!(0, $f211e3b999ad01fd$export$8a2eb51c14bb8899)(inputField) && !config.disableTouchKeyboard) {
                this._showing = true;
                inputField.focus();
                delete this._showing;
            }
        }
        this.picker.show();
    }
    /**
   * Hide the picker element
   * Not available on inline picker
   */ hide() {
        if (!this.inputField) return;
        this.picker.hide();
        this.picker.update().changeView(this.config.startView).render();
    }
    /**
   * Toggle the display of the picker element
   * Not available on inline picker
   *
   * Unlike hide(), the picker does not return to the start view when hiding.
   */ toggle() {
        if (!this.picker.active) this.show();
        else if (this.inputField) this.picker.hide();
    }
    /**
   * Destroy the Datepicker instance
   * @return {Detepicker} - the instance destroyed
   */ destroy() {
        this.hide();
        (0, $7d9bfbde81d6cbf0$export$6d7c595df9011c5)(this);
        this.picker.detach();
        const element = this.element;
        element.classList.remove('datepicker-input');
        delete element.datepicker;
        return this;
    }
    /**
   * Get the selected date(s)
   *
   * The method returns a Date object of selected date by default, and returns
   * an array of selected dates in multidate mode. If format string is passed,
   * it returns date string(s) formatted in given format.
   *
   * @param  {String} [format] - format string to stringify the date(s)
   * @return {Date|String|Date[]|String[]} - selected date(s), or if none is
   * selected, empty array in multidate mode and undefined in sigledate mode
   */ getDate(format) {
        const callback = $540e774e7a459390$var$getOutputConverter(this, format);
        if (this.config.multidate) return this.dates.map(callback);
        if (this.dates.length > 0) return callback(this.dates[0]);
    }
    /**
   * Set selected date(s)
   *
   * In multidate mode, you can pass multiple dates as a series of arguments
   * or an array. (Since each date is parsed individually, the type of the
   * dates doesn't have to be the same.)
   * The given dates are used to toggle the select status of each date. The
   * number of selected dates is kept from exceeding the length set to
   * maxNumberOfDates.
   *
   * With clear: true option, the method can be used to clear the selection
   * and to replace the selection instead of toggling in multidate mode.
   * If the option is passed with no date arguments or an empty dates array,
   * it works as "clear" (clear the selection then set nothing), and if the
   * option is passed with new dates to select, it works as "replace" (clear
   * the selection then set the given dates)
   *
   * When render: false option is used, the method omits re-rendering the
   * picker element. In this case, you need to call refresh() method later in
   * order for the picker element to reflect the changes. The input field is
   * refreshed always regardless of this option.
   *
   * When invalid (unparsable, repeated, disabled or out-of-range) dates are
   * passed, the method ignores them and applies only valid ones. In the case
   * that all the given dates are invalid, which is distinguished from passing
   * no dates, the method considers it as an error and leaves the selection
   * untouched. (The input field also remains untouched unless revert: true
   * option is used.)
   * Replacing the selection with the same date(s) also causes a similar
   * situation. In both cases, the method does not refresh the picker element
   * unless forceRefresh: true option is used.
   *
   * If viewDate option is used, the method changes the focused date to the
   * specified date instead of the last item of the selection.
   *
   * @param {...(Date|Number|String)|Array} [dates] - Date strings, Date
   * objects, time values or mix of those for new selection
   * @param {Object} [options] - function options
   * - clear: {boolean} - Whether to clear the existing selection
   *     default: false
   * - render: {boolean} - Whether to re-render the picker element
   *     default: true
   * - autohide: {boolean} - Whether to hide the picker element after re-render
   *     Ignored when used with render: false
   *     default: config.autohide
   * - revert: {boolean} - Whether to refresh the input field when all the
   *     passed dates are invalid
   *     default: false
   * - forceRefresh: {boolean} - Whether to refresh the picker element when
   *     passed dates don't change the existing selection
   *     default: false
   * - viewDate: {Date|Number|String} - Date to be focused after setiing date(s)
   *     default: The last item of the resulting selection, or defaultViewDate
   *     config option if none is selected
   */ setDate(...args) {
        const dates = [
            ...args
        ];
        const opts = {};
        const lastArg = (0, $f505456f79607dba$export$60b8b41c1898ab89)(args);
        if (lastArg && typeof lastArg === 'object' && !Array.isArray(lastArg) && !(lastArg instanceof Date)) Object.assign(opts, dates.pop());
        const inputDates = Array.isArray(dates[0]) ? dates[0] : dates;
        $540e774e7a459390$var$setDate(this, inputDates, opts);
    }
    /**
   * Update the selected date(s) with input field's value
   * Not available on inline picker
   *
   * The input field will be refreshed with properly formatted date string.
   *
   * In the case that all the entered dates are invalid (unparsable, repeated,
   * disabled or out-of-range), which is distinguished from empty input field,
   * the method leaves the input field untouched as well as the selection by
   * default. If revert: true option is used in this case, the input field is
   * refreshed with the existing selection.
   * The method also doesn't refresh the picker element in this case and when
   * the entered dates are the same as the existing selection. If
   * forceRefresh: true option is used, the picker element is refreshed in
   * these cases too.
   *
   * @param  {Object} [options] - function options
   * - autohide: {boolean} - whether to hide the picker element after refresh
   *     default: false
   * - revert: {boolean} - Whether to refresh the input field when all the
   *     passed dates are invalid
   *     default: false
   * - forceRefresh: {boolean} - Whether to refresh the picer element when
   *     input field's value doesn't change the existing selection
   *     default: false
   */ update(options) {
        if (!this.inputField) return;
        const opts = Object.assign(options || {}, {
            clear: true,
            render: true,
            viewDate: undefined
        });
        const inputDates = (0, $f505456f79607dba$export$b9ca061da17f2d30)(this.inputField.value, this.config.dateDelimiter);
        $540e774e7a459390$var$setDate(this, inputDates, opts);
    }
    /**
   * Get the focused date
   *
   * The method returns a Date object of focused date by default. If format
   * string is passed, it returns date string formatted in given format.
   *
   * @param  {String} [format] - format string to stringify the date
   * @return {Date|String} - focused date (viewDate)
   */ getFocusedDate(format) {
        return $540e774e7a459390$var$getOutputConverter(this, format)(this.picker.viewDate);
    }
    /**
   * Set focused date
   *
   * By default, the method updates the focus on the view shown at the time,
   * or the one set to the startView config option if the picker is hidden.
   * When resetView: true is passed, the view displayed is changed to the
   * pickLevel config option's if the picker is shown.
   *
   * @param {Date|Number|String} viewDate - date string, Date object, time
   * values of the date to focus
   * @param {Boolean} [resetView] - whether to change the view to pickLevel
   * config option's when the picker is shown. Ignored when the picker is
   * hidden
   */ setFocusedDate(viewDate, resetView = false) {
        const { config: config, picker: picker, active: active, rangeSideIndex: rangeSideIndex } = this;
        const pickLevel = config.pickLevel;
        const newViewDate = (0, $a2e8904b6110f6c8$export$6b862160d295c8e)(viewDate, config.format, config.locale);
        if (newViewDate === undefined) return;
        picker.changeFocus((0, $0ff2c8d69c31afd2$export$5327a72746f6632f)(newViewDate, pickLevel, rangeSideIndex));
        if (active && resetView) picker.changeView(pickLevel);
        picker.render();
    }
    /**
   * Refresh the picker element and the associated input field
   * @param {String} [target] - target item when refreshing one item only
   * 'picker' or 'input'
   * @param {Boolean} [forceRender] - whether to re-render the picker element
   * regardless of its state instead of optimized refresh
   */ refresh(target, forceRender = false) {
        if (target && typeof target !== 'string') {
            forceRender = target;
            target = undefined;
        }
        let mode;
        if (target === 'picker') mode = 2;
        else if (target === 'input') mode = 1;
        else mode = 3;
        $540e774e7a459390$var$refreshUI(this, mode, !forceRender);
    }
    /**
   * Enter edit mode
   * Not available on inline picker or when the picker element is hidden
   */ enterEditMode() {
        const inputField = this.inputField;
        if (!inputField || inputField.readOnly || !this.picker.active || this.editMode) return;
        this.editMode = true;
        inputField.classList.add('in-edit');
    }
    /**
   * Exit from edit mode
   * Not available on inline picker
   * @param  {Object} [options] - function options
   * - update: {boolean} - whether to call update() after exiting
   *     If false, input field is revert to the existing selection
   *     default: false
   */ exitEditMode(options) {
        if (!this.inputField || !this.editMode) return;
        const opts = Object.assign({
            update: false
        }, options);
        delete this.editMode;
        this.inputField.classList.remove('in-edit');
        if (opts.update) this.update(opts);
    }
    /**
   * Create a date picker
   * @param  {Element} element - element to bind a date picker
   * @param  {Object} [options] - config options
   * @param  {DateRangePicker} [rangepicker] - DateRangePicker instance the
   * date picker belongs to. Use this only when creating date picker as a part
   * of date range picker
   */ constructor(element, options = {}, rangepicker){
        element.datepicker = this;
        this.element = element;
        this.dates = [];
        // initialize config
        const config = this.config = Object.assign({
            buttonClass: options.buttonClass && String(options.buttonClass) || 'button',
            container: null,
            defaultViewDate: (0, $0ff2c8d69c31afd2$export$d0bdf45af03a6ea3)(),
            maxDate: undefined,
            minDate: undefined
        }, (0, $6dc6fcbfb2ef5738$export$2e2bcd8739ae039)((0, $c27ba36c0aa51153$export$2e2bcd8739ae039), this));
        // configure by type
        let inputField;
        if (element.tagName === 'INPUT') {
            inputField = this.inputField = element;
            inputField.classList.add('datepicker-input');
            if (options.container) // omit string type check because it doesn't guarantee to avoid errors
            // (invalid selector string causes abend with syntax error)
            config.container = options.container instanceof HTMLElement ? options.container : document.querySelector(options.container);
        } else config.container = element;
        if (rangepicker) {
            // check validiry
            const index = rangepicker.inputs.indexOf(inputField);
            const datepickers = rangepicker.datepickers;
            if (index < 0 || index > 1 || !Array.isArray(datepickers)) throw Error('Invalid rangepicker object.');
            // attach itaelf to the rangepicker here so that processInputDates() can
            // determine if this is the range-end picker of the rangepicker while
            // setting initial values when pickLevel > 0
            datepickers[index] = this;
            this.rangepicker = rangepicker;
            this.rangeSideIndex = index;
        }
        // set up config
        this._options = options;
        Object.assign(config, (0, $6dc6fcbfb2ef5738$export$2e2bcd8739ae039)(options, this));
        config.shortcutKeys = (0, $40093450f3cc365f$export$2e2bcd8739ae039)(options.shortcutKeys || {});
        // process initial value
        const initialDates = (0, $f505456f79607dba$export$b9ca061da17f2d30)(element.value || element.dataset.date, config.dateDelimiter);
        delete element.dataset.date;
        const inputDateValues = $540e774e7a459390$var$processInputDates(this, initialDates);
        if (inputDateValues && inputDateValues.length > 0) this.dates = inputDateValues;
        if (inputField) inputField.value = $540e774e7a459390$var$stringifyDates(this.dates, config);
        // set up picekr element
        const picker = this.picker = new (0, $351a502eef50e15d$export$2e2bcd8739ae039)(this);
        const keydownListener = [
            element,
            'keydown',
            (0, $c0f4f1bd39256c35$export$4506a59cef813c8b).bind(null, this)
        ];
        if (inputField) (0, $7d9bfbde81d6cbf0$export$ff47556151e281cc)(this, [
            keydownListener,
            [
                inputField,
                'focus',
                (0, $c0f4f1bd39256c35$export$ecf9bf35ad97eb74).bind(null, this)
            ],
            [
                inputField,
                'mousedown',
                (0, $c0f4f1bd39256c35$export$39ad0b1f682358f9).bind(null, this)
            ],
            [
                inputField,
                'click',
                (0, $c0f4f1bd39256c35$export$c7705f5678ebdc61).bind(null, this)
            ],
            [
                inputField,
                'paste',
                (0, $c0f4f1bd39256c35$export$48aae1120b60938a).bind(null, this)
            ],
            // To detect a click on outside, just listening to mousedown is enough,
            // no need to listen to touchstart.
            // Actually, listening to touchstart can be a problem because, while
            // mousedown is fired only on tapping but not on swiping/pinching,
            // touchstart is fired on swiping/pinching as well.
            // (issue #95)
            [
                document,
                'mousedown',
                (0, $59f7e80e6f007ef4$export$806d9a98fb0e6fd0).bind(null, this)
            ],
            [
                window,
                'resize',
                picker.place.bind(picker)
            ]
        ]);
        else {
            (0, $7d9bfbde81d6cbf0$export$ff47556151e281cc)(this, [
                keydownListener
            ]);
            this.show();
        }
    }
}





// filter out the config options inapproprite to pass to Datepicker
function $c9b5484c388a3010$var$filterOptions(options) {
    const newOpts = Object.assign({}, options);
    delete newOpts.inputs;
    delete newOpts.allowOneSidedRange;
    delete newOpts.maxNumberOfDates; // to ensure each datepicker handles a single date
    return newOpts;
}
function $c9b5484c388a3010$var$setupDatepicker(rangepicker, changeDateListener, el, options) {
    (0, $7d9bfbde81d6cbf0$export$ff47556151e281cc)(rangepicker, [
        [
            el,
            'changeDate',
            changeDateListener
        ]
    ]);
    new (0, $540e774e7a459390$export$2e2bcd8739ae039)(el, options, rangepicker);
}
function $c9b5484c388a3010$var$onChangeDate(rangepicker, ev) {
    // to prevent both datepickers trigger the other side's update each other
    if (rangepicker._updating) return;
    rangepicker._updating = true;
    const target = ev.target;
    if (target.datepicker === undefined) return;
    const datepickers = rangepicker.datepickers;
    const [datepicker0, datepicker1] = datepickers;
    const setDateOptions = {
        render: false
    };
    const changedSide = rangepicker.inputs.indexOf(target);
    const otherSide = changedSide === 0 ? 1 : 0;
    const changedDate = datepickers[changedSide].dates[0];
    const otherDate = datepickers[otherSide].dates[0];
    if (changedDate !== undefined && otherDate !== undefined) {
        // if the start of the range > the end, swap them
        if (changedSide === 0 && changedDate > otherDate) {
            datepicker0.setDate(otherDate, setDateOptions);
            datepicker1.setDate(changedDate, setDateOptions);
        } else if (changedSide === 1 && changedDate < otherDate) {
            datepicker0.setDate(changedDate, setDateOptions);
            datepicker1.setDate(otherDate, setDateOptions);
        }
    } else if (!rangepicker.allowOneSidedRange) // to prevent the range from becoming one-sided, copy changed side's
    // selection (no matter if it's empty) to the other side
    {
        if (changedDate !== undefined || otherDate !== undefined) {
            setDateOptions.clear = true;
            datepickers[otherSide].setDate(datepickers[changedSide].dates, setDateOptions);
        }
    }
    datepickers.forEach((datepicker)=>{
        datepicker.picker.update().render();
    });
    delete rangepicker._updating;
}
class $c9b5484c388a3010$export$2e2bcd8739ae039 {
    /**
   * Set new values to the config options
   * @param {Object} options - config options to update
   */ setOptions(options) {
        this.allowOneSidedRange = !!options.allowOneSidedRange;
        const cleanOptions = $c9b5484c388a3010$var$filterOptions(options);
        this.datepickers.forEach((datepicker)=>{
            datepicker.setOptions(cleanOptions);
        });
    }
    /**
   * Destroy the DateRangePicker instance
   * @return {DateRangePicker} - the instance destroyed
   */ destroy() {
        this.datepickers.forEach((datepicker)=>{
            datepicker.destroy();
        });
        (0, $7d9bfbde81d6cbf0$export$6d7c595df9011c5)(this);
        delete this.element.rangepicker;
    }
    /**
   * Get the start and end dates of the date range
   *
   * The method returns Date objects by default. If format string is passed,
   * it returns date strings formatted in given format.
   * The result array always contains 2 items (start date/end date) and
   * undefined is used for unselected side. (e.g. If none is selected,
   * the result will be [undefined, undefined]. If only the end date is set
   * when allowOneSidedRange config option is true, [undefined, endDate] will
   * be returned.)
   *
   * @param  {String} [format] - Format string to stringify the dates
   * @return {Array} - Start and end dates
   */ getDates(format) {
        const callback = format ? (date)=>(0, $a2e8904b6110f6c8$export$3ae94a2503e890a1)(date, format, this.datepickers[0].config.locale) : (date)=>new Date(date);
        return this.dates.map((date)=>date === undefined ? date : callback(date));
    }
    /**
   * Set the start and end dates of the date range
   *
   * The method calls datepicker.setDate() internally using each of the
   * arguments in start→end order.
   *
   * When a clear: true option object is passed instead of a date, the method
   * clears the date.
   *
   * If an invalid date, the same date as the current one or an option object
   * without clear: true is passed, the method considers that argument as an
   * "ineffective" argument because calling datepicker.setDate() with those
   * values makes no changes to the date selection.
   *
   * When the allowOneSidedRange config option is false, passing {clear: true}
   * to clear the range works only when it is done to the last effective
   * argument (in other words, passed to rangeEnd or to rangeStart along with
   * ineffective rangeEnd). This is because when the date range is changed,
   * it gets normalized based on the last change at the end of the changing
   * process.
   *
   * @param {Date|Number|String|Object} rangeStart - Start date of the range
   * or {clear: true} to clear the date
   * @param {Date|Number|String|Object} rangeEnd - End date of the range
   * or {clear: true} to clear the date
   */ setDates(rangeStart, rangeEnd) {
        const { datepickers: [datepicker0, datepicker1], inputs: [input0, input1], dates: [origDate0, origDate1] } = this;
        // If range normalization runs on every change, we can't set a new range
        // that starts after the end of the current range correctly because the
        // normalization process swaps start↔︎end right after setting the new start
        // date. To prevent this, the normalization process needs to run once after
        // both of the new dates are set.
        this._updating = true;
        datepicker0.setDate(rangeStart);
        datepicker1.setDate(rangeEnd);
        delete this._updating;
        if (datepicker1.dates[0] !== origDate1) $c9b5484c388a3010$var$onChangeDate(this, {
            target: input1
        });
        else if (datepicker0.dates[0] !== origDate0) $c9b5484c388a3010$var$onChangeDate(this, {
            target: input0
        });
    }
    /**
   * Create a date range picker
   * @param  {Element} element - element to bind a date range picker
   * @param  {Object} [options] - config options
   */ constructor(element, options = {}){
        let inputs = Array.isArray(options.inputs) ? options.inputs : Array.from(element.querySelectorAll('input'));
        if (inputs.length < 2) return;
        element.rangepicker = this;
        this.element = element;
        this.inputs = inputs = inputs.slice(0, 2);
        Object.freeze(inputs);
        this.allowOneSidedRange = !!options.allowOneSidedRange;
        const changeDateListener = $c9b5484c388a3010$var$onChangeDate.bind(null, this);
        const cleanOptions = $c9b5484c388a3010$var$filterOptions(options);
        // in order for initial date setup to work right when pcicLvel > 0,
        // let Datepicker constructor add the instance to the rangepicker
        const datepickers = this.datepickers = [];
        inputs.forEach((input)=>{
            $c9b5484c388a3010$var$setupDatepicker(this, changeDateListener, input, cleanOptions);
        });
        Object.freeze(datepickers);
        Object.defineProperty(this, 'dates', {
            get () {
                return datepickers.map((datepicker)=>datepicker.dates[0]);
            }
        });
        // normalize the range if initial dates are given
        if (datepickers[0].dates.length > 0) $c9b5484c388a3010$var$onChangeDate(this, {
            target: inputs[0]
        });
        else if (datepickers[1].dates.length > 0) $c9b5484c388a3010$var$onChangeDate(this, {
            target: inputs[1]
        });
    }
}





const $3d10c89f521304af$var$loadJson = async (fileName)=>{
    const response = await fetch(`https://bookings.skipbinbrisbane.com.au/json/${fileName}.json`, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
    return response.json();
};
const $3d10c89f521304af$var$showExtraDaysInfo = (extraDays)=>{
    const formCharge = document.getElementById('charge');
    const formExtraDays = document.getElementById('extra-days');
    const extraDaysInfo = document.getElementById('extra-days-info');
    const extraDaysRate = document.getElementById('extra-days-rate');
    const infoCharge = document.getElementById('info-charge-2');
    const infoExtraDays = document.getElementById('info-extra-days-2');
    const infoSubtotal = document.getElementById('info-subtotal-2');
    const extraDayRate = window[(0, $ba6ed7a7b724d112$export$2e2bcd8739ae039).globalScope].options.costs.per_day_over || 0;
    extraDaysRate.textContent = extraDayRate.toFixed(2);
    const charge = +formCharge.value;
    const extraDayCost = extraDays > 0 ? extraDays * extraDayRate : 0;
    formExtraDays.value = extraDayCost;
    const subtotal = charge + extraDayCost;
    infoCharge.textContent = charge.toFixed(2);
    infoExtraDays.textContent = extraDayCost.toFixed(2);
    infoSubtotal.textContent = subtotal.toFixed(2);
    extraDaysInfo.style.display = extraDays > 0 ? 'block' : 'none';
};
const $3d10c89f521304af$var$initStep2 = async ()=>{
    const deliveryDate = document.getElementById('delivery-date');
    const deliveryDateIcon = document.getElementById('delivery-date-icon');
    const pickupDate = document.getElementById('pickup-date');
    const pickupDateIcon = document.getElementById('pickup-date-icon');
    const suburbPostcode = document.getElementById('suburb');
    const [days, suburbs] = await Promise.all([
        $3d10c89f521304af$var$loadJson('days'),
        $3d10c89f521304af$var$loadJson('suburbs')
    ]);
    window[(0, $ba6ed7a7b724d112$export$2e2bcd8739ae039).globalScope].options.days = days;
    window[(0, $ba6ed7a7b724d112$export$2e2bcd8739ae039).globalScope].options.suburbs = suburbs;
    const date = new Date();
    date.setDate(date.getDate() + 1);
    const options = {
        buttonClass: 'btn',
        format: 'dd/mm/yyyy',
        minDate: date,
        orientation: 'bottom',
        datesDisabled: [],
        daysOfWeekDisabled: days.exclude_days || []
    };
    for(let i = 0; i < (days.exclude_dates || []).length; i += 1)options.datesDisabled[i] = new Date(`${days.exclude_dates[i]} 00:00:00`);
    const deliveryDatepicker = new (0, $540e774e7a459390$export$2e2bcd8739ae039)(deliveryDate, options);
    const pickupDatepicker = new (0, $540e774e7a459390$export$2e2bcd8739ae039)(pickupDate, options);
    const processDates = ()=>{
        const delDate = deliveryDatepicker.getDate();
        const pickDate = pickupDatepicker.getDate();
        if (delDate) pickupDatepicker.setOptions({
            minDate: delDate
        });
        if (delDate && pickDate) {
            if (pickDate < delDate) {
                pickupDatepicker.setDate(delDate);
                return;
            }
            const oneDay = 86400000;
            const diffInTime = pickDate.getTime() - delDate.getTime();
            const diffInDays = Math.ceil(diffInTime / oneDay);
            const maxDays = 7;
            $3d10c89f521304af$var$showExtraDaysInfo(diffInDays - maxDays);
        }
    };
    deliveryDate.addEventListener('changeDate', processDates);
    pickupDate.addEventListener('changeDate', processDates);
    deliveryDateIcon.addEventListener('click', ()=>deliveryDatepicker.show());
    pickupDateIcon.addEventListener('click', ()=>pickupDatepicker.show());
    let html = '';
    for(let i = 0; i < suburbs.length; i += 1){
        const [postcode, suburb] = suburbs[i];
        html += `<option value="${suburb} ${postcode}">${suburb} ${postcode}</option>`;
    }
    suburbPostcode.insertAdjacentHTML('beforeend', html);
};
var $3d10c89f521304af$export$2e2bcd8739ae039 = $3d10c89f521304af$var$initStep2;


const $7664a66ac285f258$var$initStep3 = ()=>{};
var $7664a66ac285f258$export$2e2bcd8739ae039 = $7664a66ac285f258$var$initStep3;





const $fb6e5cbe9550420e$var$getClientToken = async ()=>{
    const response = await fetch(`${(0, $ba6ed7a7b724d112$export$2e2bcd8739ae039).apiUri}/bookings/get-token`, {
        headers: {
            Accept: 'application/json'
        }
    });
    return response.json();
};
const $fb6e5cbe9550420e$var$loadScript = async (src)=>{
    return new Promise((resolve)=>{
        const script = document.createElement('script');
        script.async = true;
        script.defer = true;
        script.onload = ()=>{
            resolve();
        };
        document.head.appendChild(script);
        script.src = src;
    });
};
const $fb6e5cbe9550420e$var$processBraintree = async ()=>{
    try {
        const payload = await window[(0, $ba6ed7a7b724d112$export$2e2bcd8739ae039).globalScope].dropinInstance.requestPaymentMethod();
        const paymentNonce = document.getElementById('payment-nonce');
        paymentNonce.value = payload.nonce;
        const dropinContainer = document.getElementById('dropin-container');
        dropinContainer.classList.remove('is-invalid');
        const form = document.getElementById('form');
        const paymentMethods = form.querySelectorAll('input[name="payment_method"]');
        paymentMethods.forEach((radio)=>radio.setAttribute('disabled', ''));
        const creditCardOption = document.getElementById('payment-method-3');
        if (creditCardOption) creditCardOption.checked = true;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error processing Braintree payment:', error);
    }
};
const $fb6e5cbe9550420e$export$716504bb4f7e394d = async ()=>{
    try {
        const [token] = await Promise.all([
            $fb6e5cbe9550420e$var$getClientToken(),
            $fb6e5cbe9550420e$var$loadScript('https://js.braintreegateway.com/web/dropin/1.46.0/js/dropin.min.js')
        ]);
        window[(0, $ba6ed7a7b724d112$export$2e2bcd8739ae039).globalScope].clientToken = token.data;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error initializing Braintree:', error);
    }
};
const $fb6e5cbe9550420e$export$fd2d5a0fcfbcb5cb = async ()=>{
    if (window[(0, $ba6ed7a7b724d112$export$2e2bcd8739ae039).globalScope].clientToken) try {
        const dropinInstance = await window.braintree.dropin.create({
            authorization: window[(0, $ba6ed7a7b724d112$export$2e2bcd8739ae039).globalScope].clientToken,
            container: '#dropin-container',
            card: {
                overrides: {
                    fields: {
                        number: {
                            // May not need this on production, supported card brands may be determined by Braintree account settings
                            supportedCardBrands: {
                                visa: true,
                                mastercard: true,
                                'american-express': false,
                                discover: false,
                                jcb: false
                            }
                        }
                    }
                }
            }
        });
        window[(0, $ba6ed7a7b724d112$export$2e2bcd8739ae039).globalScope].dropinInstance = dropinInstance;
        dropinInstance.on('paymentMethodRequestable', ()=>{
            $fb6e5cbe9550420e$var$processBraintree();
        });
        const form = document.getElementById('form');
        const backButton = form.querySelector('a[data-current="4"]');
        if (backButton) {
            backButton.classList.add('disabled');
            backButton.setAttribute('tabindex', '-1');
            backButton.setAttribute('aria-disabled', 'true');
            backButton.addEventListener('click', (e)=>{
                e.preventDefault();
            });
        }
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error initializing Braintree client:', error);
    }
};


const $d4557cc5d482f5af$export$60fc47fdd6a2e210 = (disable = true)=>{
    const form = document.getElementById('form');
    const buttons = form.querySelectorAll('a[data-current="4"]');
    const cog = document.getElementById('submit-cog');
    buttons.forEach((button)=>{
        if (disable) button.classList.add('disabled');
        else button.classList.remove('disabled');
    });
    if (disable) cog.classList.add('fa-spin');
    else cog.classList.remove('fa-spin');
};
const $d4557cc5d482f5af$var$disableForm = (form)=>{
    const paymentMethods = form.querySelectorAll('input[name="payment_method"]');
    const buttons = form.querySelectorAll('a[data-current="4"]');
    const cog = document.getElementById('submit-cog');
    paymentMethods.forEach((radio)=>radio.setAttribute('disabled', ''));
    buttons.forEach((button)=>{
        const { style: style } = button;
        style.display = 'none';
    });
    cog.style.display = 'none';
};
const $d4557cc5d482f5af$var$getFormValues = (form)=>{
    const fields = form.querySelectorAll('input, select, textarea');
    const formData = {};
    fields.forEach((field)=>{
        if (field.name !== 'g-recaptcha-response' && field.name !== '' && (![
            'checkbox',
            'radio'
        ].includes(field.type) || field.checked === true)) formData[field.name] = field.value;
    });
    return formData;
};
const $d4557cc5d482f5af$var$executeReCaptcha = async ()=>{
    const successAlert = document.getElementById('success-alert');
    const errorAlert = document.getElementById('error-alert');
    successAlert.style.display = 'none';
    errorAlert.style.display = 'none';
    $d4557cc5d482f5af$export$60fc47fdd6a2e210();
    window.grecaptcha.execute();
};
const $d4557cc5d482f5af$var$postData = async (formData)=>{
    const response = await fetch(`${(0, $ba6ed7a7b724d112$export$2e2bcd8739ae039).apiUri}/bookings`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    });
    return response.json();
};
const $d4557cc5d482f5af$var$showResult = (json)=>{
    const type = json.success ? 'success' : 'error';
    const alert = document.getElementById(`${type}-alert`);
    const message = document.getElementById(`${type}-message`);
    message.textContent = json.message;
    alert.style.display = 'block';
};
const $d4557cc5d482f5af$export$e02251cfbe407ee6 = async ()=>{
    const form = document.getElementById('form');
    const dropinContainer = document.getElementById('dropin-container');
    const formData = $d4557cc5d482f5af$var$getFormValues(form);
    if (formData.payment_method === 'Credit Card' && !formData.payment_nonce) {
        if (!window[(0, $ba6ed7a7b724d112$export$2e2bcd8739ae039).globalScope].dropinInstance) (0, $fb6e5cbe9550420e$export$fd2d5a0fcfbcb5cb)();
        else dropinContainer.classList.add('is-invalid');
        $d4557cc5d482f5af$export$60fc47fdd6a2e210(false);
        return;
    }
    const recaptchaToken = document.getElementById('recaptcha-token');
    if (recaptchaToken.value === '') {
        $d4557cc5d482f5af$var$executeReCaptcha();
        return;
    }
    const json = await $d4557cc5d482f5af$var$postData(formData);
    if (json.success) $d4557cc5d482f5af$var$disableForm(form);
    else {
        window.grecaptcha.reset();
        document.getElementById('recaptcha-token').value = '';
        $d4557cc5d482f5af$export$60fc47fdd6a2e210(false);
    }
    $d4557cc5d482f5af$var$showResult(json);
};


const $4f5232ff66088e52$var$updatePrice = (charge, extraDays, weight)=>{
    const formTotal = document.getElementById('total');
    const infoCharge = document.getElementById('info-charge');
    const infoExtraDays = document.getElementById('info-extra-days');
    const infoTotal = document.getElementById('info-total');
    const weightDisplay = document.getElementById('weight-display-4');
    const weightRate = document.getElementById('weight-rate-4');
    const total = charge + extraDays;
    formTotal.value = total.toFixed(2);
    infoCharge.textContent = charge.toFixed(2);
    infoExtraDays.textContent = extraDays.toFixed(2);
    infoTotal.textContent = total.toFixed(2);
    weightDisplay.textContent = weight;
    weightRate.textContent = (window[(0, $ba6ed7a7b724d112$export$2e2bcd8739ae039).globalScope].options.costs.per_100kg_over || 0).toFixed(2);
};
const $4f5232ff66088e52$var$calculatePrice = ()=>{
    const formCharge = document.getElementById('charge');
    const formExtraDays = document.getElementById('extra-days');
    const formWeight = document.getElementById('weight');
    const charge = formCharge.value > 0 ? +formCharge.value : 0;
    const extraDays = formExtraDays.value > 0 ? +formExtraDays.value : 0;
    const weight = formWeight.value > 0 ? +formWeight.value : 0;
    $4f5232ff66088e52$var$updatePrice(charge, extraDays, weight);
};
const $4f5232ff66088e52$var$initStep4 = ()=>{
    $4f5232ff66088e52$var$calculatePrice();
    const paymentMethods = document.querySelectorAll('input[name="payment_method"]');
    const directDepositInfo = document.getElementById('direct-deposit-info');
    // const chequeInfo = document.getElementById('cheque-info');
    const dropinWrapper = document.getElementById('dropin-wrapper');
    paymentMethods.forEach((radio)=>radio.addEventListener('change', ()=>{
            if (radio.value === 'Direct Deposit') directDepositInfo.style.display = 'block';
            else directDepositInfo.style.display = 'none';
            /* if (radio.value === 'Cheque') {
				chequeInfo.style.display = 'block';
			} else {
				chequeInfo.style.display = 'none';
			} */ if (radio.value === 'Credit Card') dropinWrapper.style.display = 'block';
            else dropinWrapper.style.display = 'none';
            (0, $d4557cc5d482f5af$export$60fc47fdd6a2e210)(false);
        }));
};
var $4f5232ff66088e52$export$2e2bcd8739ae039 = $4f5232ff66088e52$var$initStep4;





const $fbd459842a61896e$var$onloadCallback = ()=>{
    window.grecaptcha.render('recaptcha', {
        sitekey: (0, $ba6ed7a7b724d112$export$2e2bcd8739ae039).reCaptchaKey,
        size: 'invisible',
        badge: 'inline',
        callback: window.recaptchaVerified,
        'error-callback': window.recaptchaError,
        'expired-callback': window.recaptchaExpired
    });
};
const $fbd459842a61896e$var$verifiedCallback = (token)=>{
    const recaptchaToken = document.getElementById('recaptcha-token');
    recaptchaToken.value = token;
    (0, $d4557cc5d482f5af$export$e02251cfbe407ee6)();
};
const $fbd459842a61896e$var$errorCallback = ()=>{
    window.grecaptcha.reset();
    (0, $d4557cc5d482f5af$export$60fc47fdd6a2e210)(false);
};
const $fbd459842a61896e$var$expiredCallback = ()=>{
    const successAlert = document.getElementById('success-alert');
    const cog = document.getElementById('submit-cog');
    if (successAlert.style.display === 'none' && !cog.classList.contains('fa-spin')) {
        window.grecaptcha.reset();
        (0, $d4557cc5d482f5af$export$60fc47fdd6a2e210)(false);
    }
};
const $fbd459842a61896e$export$6125b5139919eead = ()=>{
    window.recaptchaOnload = $fbd459842a61896e$var$onloadCallback;
    window.recaptchaVerified = $fbd459842a61896e$var$verifiedCallback;
    window.recaptchaError = $fbd459842a61896e$var$errorCallback;
    window.recaptchaExpired = $fbd459842a61896e$var$expiredCallback;
    const script = document.createElement('script');
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
    script.src = 'https://www.google.com/recaptcha/api.js?onload=recaptchaOnload&render=explicit';
};



/* eslint-disable import/no-unresolved */ var $b0ec503ef7bd41c8$exports = {};
$b0ec503ef7bd41c8$exports = "<header id=header>\n\t<div class=container id=contact>\n\t\t<div class=row>\n\t\t\t<div class=col-sm-6>\n\t\t\t\t<img src=/ecoclear-logo.9f6c5a1f.png alt=\"EcoClear logo\" width=235 height=37 class=img-fluid id=logo>\n\t\t\t</div>\n\t\t\t<address class=col-sm-6>\n\t\t\t\t<i class=\"fa-phone fas\"></i>\n\t\t\t\t<a href=tel:+61733433030>07 3343 3030</a><br>\n\t\t\t\t<i class=\"fa-at fas\"></i>\n\t\t\t\t<a href=mailto:info@skipbinbrisbane.com.au>info@skipbinbrisbane.com.au</a><br>\n\t\t\t\t<i class=\"fa-map-marker-alt fas\"></i> PO Box 6172, Fairfield\n\t\t\t\tGardens, QLD 4103\n\t\t\t</address>\n\t\t</div>\n\t</div>\n\t<div id=heading>\n\t\t<div class=container>\n\t\t\t<h1>Skip Bin Hire</h1>\n\t\t</div>\n\t</div>\n</header>\n<main id=main></main>\n<footer id=footer>\n\t<div class=container>\n\t\t© Copyright 2021 Skip Bins Brisbane. All Rights Reserved.\n\t</div>\n</footer>\n";


var $230fae5e1d1a794f$exports = {};
$230fae5e1d1a794f$exports = "<div class=container>\n\t<h1>Page Not Found</h1>\n</div>\n";


const $3b3032dc372cff03$export$154c38a9894cf6d9 = (embed = false)=>{
    const existing = document.getElementById('main');
    if (existing) return existing;
    const app = document.getElementById('app');
    app.insertAdjacentHTML('afterbegin', (0, (/*@__PURE__*/$parcel$interopDefault($b0ec503ef7bd41c8$exports))));
    if (embed) {
        document.getElementById('header').style.display = 'none';
        document.getElementById('footer').style.display = 'none';
        document.getElementById('main').classList.add('embedded');
    }
    return document.getElementById('main');
};
const $3b3032dc372cff03$export$a33e918cb4258370 = ()=>{
    const main = $3b3032dc372cff03$export$154c38a9894cf6d9();
    main.innerHTML = (0, (/*@__PURE__*/$parcel$interopDefault($230fae5e1d1a794f$exports)));
};


const $e23963064c889102$var$formStepTemplates = {
    step1: (/*@__PURE__*/$parcel$interopDefault($323d191892a3c904$exports)),
    step2: (/*@__PURE__*/$parcel$interopDefault($8cb04d1943ddc6b0$exports)),
    step3: (/*@__PURE__*/$parcel$interopDefault($24aba854f01c6ecb$exports)),
    step4: (/*@__PURE__*/$parcel$interopDefault($0955b4e2f78c9223$exports))
};
const $e23963064c889102$var$initFormSteps = {
    step1: (0, $e96af7e1be5f18d8$export$2e2bcd8739ae039),
    step2: (0, $3d10c89f521304af$export$2e2bcd8739ae039),
    step3: (0, $7664a66ac285f258$export$2e2bcd8739ae039),
    step4: (0, $4f5232ff66088e52$export$2e2bcd8739ae039)
};
const $e23963064c889102$var$enableValidation = ()=>{
    const form = document.getElementById('form');
    form.addEventListener('submit', (event)=>{
        if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
        }
        form.classList.add('was-validated');
    });
};
const $e23963064c889102$var$checkValidation = (step)=>{
    const fieldset = document.getElementById(`step-${step}`);
    fieldset.classList.add('was-validated');
    /* const fields = [...fieldset.querySelectorAll('input, select, textarea')];
	for (let i = 0; i < fields.length; i += 1) {
		fields[i].checkValidity();
	} */ return fieldset.querySelectorAll('input:invalid, select:invalid, textarea:invalid').length === 0;
};
const $e23963064c889102$var$clearValidation = (step)=>{
    const fieldset = document.getElementById(`step-${step}`);
    fieldset.classList.remove('was-validated');
};
const $e23963064c889102$export$80479f8d15f127c8 = (embed = false)=>{
    const existing = document.getElementById('steps');
    if (existing) return existing;
    const main = (0, $3b3032dc372cff03$export$154c38a9894cf6d9)(embed);
    main.innerHTML = (0, (/*@__PURE__*/$parcel$interopDefault($35ea7bdc381cb865$exports)));
    if (embed) document.getElementById('main-container').classList.replace('container', 'container-fluid');
    $e23963064c889102$var$enableValidation();
    (0, $fbd459842a61896e$export$6125b5139919eead)();
    (0, $fb6e5cbe9550420e$export$716504bb4f7e394d)();
    return document.getElementById('steps');
};
const $e23963064c889102$export$93a8248e85d9160b = async (step, params = {})=>{
    if (![
        1,
        2,
        3,
        4
    ].includes(step)) return;
    const embed = (params || {}).embed === 'true';
    const steps = $e23963064c889102$export$80479f8d15f127c8(embed);
    const otherSteps = [
        ...steps.querySelectorAll(`fieldset:not(#step-${step})`)
    ];
    for(let i = 0; i < otherSteps.length; i += 1)otherSteps[i].style.display = 'none';
    const existing = document.getElementById(`step-${step}`);
    if (existing) {
        existing.style.display = 'block';
        if (step === 4) {
            const paymentMethod = document.querySelector('input[name="payment_method"]:checked');
            if (paymentMethod) paymentMethod.dispatchEvent(new Event('change'));
        }
        return;
    }
    steps.insertAdjacentHTML('beforeend', $e23963064c889102$var$formStepTemplates[`step${step}`]);
    $e23963064c889102$var$initFormSteps[`step${step}`](params);
};
const $e23963064c889102$export$6e55f347b1cf1f4e = (router)=>{
    const steps = $e23963064c889102$export$80479f8d15f127c8();
    const stepsData = steps.dataset;
    if (!stepsData.hasRouterListener) {
        stepsData.hasRouterListener = true;
        steps.addEventListener('click', (event)=>{
            const element = event.target;
            const elementData = element.dataset;
            if (elementData.step) {
                event.preventDefault();
                event.stopPropagation();
                if (element.classList.contains('disabled')) return;
                if (elementData.step === 'prev') router.navigate(element.getAttribute('href'));
                else if ($e23963064c889102$var$checkValidation(elementData.current)) {
                    $e23963064c889102$var$clearValidation(elementData.current);
                    if (elementData.current === '4') {
                        (0, $d4557cc5d482f5af$export$60fc47fdd6a2e210)();
                        (0, $d4557cc5d482f5af$export$e02251cfbe407ee6)();
                    } else router.navigate(element.getAttribute('href'));
                }
            }
        });
    }
};



const $a8c3cf22480c6129$var$router = new (0, (/*@__PURE__*/$parcel$interopDefault($7f8039d08dcbcec6$exports)))('/');
$a8c3cf22480c6129$var$router.hooks({
    before (done, match) {
        if (match.url !== '' && !document.getElementById('step-1')) {
            $a8c3cf22480c6129$var$router.navigate('/', {
                historyAPIMethod: 'replaceState',
                callHooks: false
            });
            done(false);
            return;
        }
        done();
    }
});
$a8c3cf22480c6129$var$router.on({
    '/': ({ params: params })=>{
        (0, $e23963064c889102$export$93a8248e85d9160b)(1, params).then((0, $e23963064c889102$export$6e55f347b1cf1f4e)($a8c3cf22480c6129$var$router));
    },
    '/step-2': ()=>{
        (0, $e23963064c889102$export$93a8248e85d9160b)(2);
    },
    '/step-3': ()=>{
        (0, $e23963064c889102$export$93a8248e85d9160b)(3);
    },
    '/step-4': ()=>{
        (0, $e23963064c889102$export$93a8248e85d9160b)(4);
    }
});
$a8c3cf22480c6129$var$router.notFound(()=>{
    (0, $3b3032dc372cff03$export$a33e918cb4258370)();
});
var $a8c3cf22480c6129$export$2e2bcd8739ae039 = $a8c3cf22480c6129$var$router;


(0, $a8c3cf22480c6129$export$2e2bcd8739ae039).resolve();

})();
//# sourceMappingURL=skip-bins-bookings.5e5b5f05.js.map
